// ur — checkin/quickCheck/stepTracker blocks translated.
export const ur = {
  "common": {
    "loading": "لوڈ ہو رہا ہے...",
    "save": "محفوظ کریں",
    "cancel": "منسوخ کریں",
    "delete": "حذف کریں",
    "edit": "ترمیم کریں",
    "close": "بند کریں",
    "confirm": "تصدیق کریں",
    "back": "واپس",
    "next": "اگلا",
    "submit": "جمع کرائیں",
    "search": "تلاش کریں",
    "select": "منتخب کریں",
    "or": "یا",
    "and": "اور",
    "note": "نوٹ",
    "viewAll": "سب دیکھیں",
    "learnMore": "مزید جانیں",
    "getStarted": "شروع کریں",
    "continue": "جاری رکھیں",
    "saving": "محفوظ ہو رہا ہے…"
  },
  "nav": {
    "dashboard": "ہوم",
    "nutrition": "غذائیت",
    "family": "خاندان",
    "care": "سروسز",
    "careShort": "سروسز",
    "checkIn": "چیک ان",
    "insights": "معلومات",
    "trends": "رجحانات",
    "habits": "عادتیں",
    "medications": "ادویات",
    "expertSupport": "ماہرین کی مدد",
    "profile": "پروفائل",
    "healthHub": "ہیلتھ ہب",
    "support": "سپورٹ",
    "wellness": "تندرستی",
    "education": "تعلیم",
    "community": "کمیونٹی",
    "preventiveHealth": "حفاظتی صحت",
    "womensHealth": "خواتین کی صحت",
    "reminders": "صحت کی یاد دہانیاں",
    "meals": "کھانا",
    "orders": "آرڈرز",
    "subscription": "سبسکرپشن",
    "logout": "لاگ آؤٹ"
  },

  "navShort": {
    "dashboard": "ہوم",
    "nutrition": "غذائیت",
    "family": "خاندان",
    "care": "خدمات",
    "support": "مدد",
    "profile": "پروفائل"
  },
  "auth": {
    "login": "سائن ان کریں",
    "register": "اکاؤنٹ بنائیں",
    "logout": "سائن آؤٹ کریں",
    "email": "ای میل",
    "password": "پاس ورڈ",
    "name": "پورا نام",
    "forgotPassword": "پاس ورڈ بھول گئے؟",
    "noAccount": "اکاؤنٹ نہیں ہے؟",
    "haveAccount": "پہلے سے اکاؤنٹ موجود ہے؟",
    "signInHere": "یہاں سائن ان کریں",
    "signUpHere": "یہاں سائن اپ کریں",
    "welcomeBack": "خوش آمدید!",
    "getStarted": "آئیے شروع کرتے ہیں",
    "biometricLogin": "بایومیٹرکس کے ذریعے سائن ان کریں",
    "biometricHelper": "فنگر پرنٹ، Face ID یا Windows Hello استعمال کریں",
    "vendorLogin": "وینڈر لاگ ان",
    "createOne": "نیا بنائیں",
    "tagline": "اپنی صحت کا خیال رکھیں — روزانہ ایک آسان چیک کے ساتھ۔",
    "takes30s": "صرف 30 سیکنڈ لگتے ہیں",
    "emailPlaceholder": "you@example.com",
    "passwordPlaceholder": "اپنا پاس ورڈ درج کریں",
    "checking": "چیک کیا جا رہا ہے…",
    "continue": "جاری رکھیں",
    "secureMessage": "محفوظ اور نجی — آپ کا ڈیٹا محفوظ رہتا ہے",
    "biometricSoon": "بایومیٹرک لاگ ان — جلد آ رہا ہے",
    "sessionExpired": "آپ کا سیشن ختم ہو گیا ہے۔ براہ کرم دوبارہ سائن ان کریں۔",
    "showPassword": "پاس ورڈ دکھائیں",
    "hidePassword": "پاس ورڈ چھپائیں",
    "vendor": {
      "title": "وینڈر پارٹنر لاگ ان",
      "subtitle": "اپنے HealthLoop وینڈر ڈیش بورڈ تک رسائی حاصل کریں",
      "businessEmail": "کاروباری ای میل",
      "emailPlaceholder": "vendor@business.com",
      "passwordPlaceholder": "••••••••",
      "signingIn": "سائن ان ہو رہا ہے...",
      "signIn": "سائن ان کریں",
      "notVendorYet": "ابھی تک وینڈر پارٹنر نہیں بنے؟",
      "registerBusiness": "اپنا کاروبار رجسٹر کریں",
      "areYouUser": "کیا آپ صارف ہیں؟",
      "userLogin": "صارف لاگ ان",
      "welcomeBackToast": "خوش آمدید!",
      "genericError": "لاگ ان ناکام رہا۔ براہ کرم دوبارہ کوشش کریں۔"
    },
    "admin": {
      "backToUserLogin": "صارف سائن ان",
      "title": "ایڈمن سائن ان",
      "restrictedBadge": "محدود",
      "tagline": "HealthLoop آپریٹر کنسول — ایڈمن کی اسناد درکار ہیں۔",
      "emailLabel": "ایڈمن ای میل",
      "emailPlaceholder": "admin@yourdomain.com",
      "passwordLabel": "پاس ورڈ",
      "passwordPlaceholder": "اپنا ایڈمن پاس ورڈ درج کریں",
      "signingIn": "سائن ان ہو رہا ہے…",
      "submit": "ایڈمن کنسول میں سائن ان کریں",
      "secureNote": "محفوظ کنکشن · سیشن انکرپٹڈ ہے",
      "restrictedTitle": "یہ حصہ صرف ایڈمنز کے لیے مخصوص ہے۔",
      "restrictedBody": "آپ کا اکاؤنٹ سائن ان ہے، لیکن اسے ایڈمن تک رسائی حاصل نہیں ہے۔ کسی دوسرے اکاؤنٹ سے کوشش کرنے کے لیے سائن آؤٹ کریں، یا مین ایپ پر واپس جائیں۔",
      "signOut": "سائن آؤٹ",
      "backToApp": "ایپ پر واپس جائیں"
    }
  },
  "quickCheck": {
    "header": {
      "title": "آج آپ کیسا محسوس کر رہے ہیں؟",
      "subtitle": "فوری جائزہ — اس میں 60 سیکنڈ سے بھی کم وقت لگے گا"
    },
    "section1": {
      "title": "آج آپ کیا محسوس کر رہے ہیں؟",
      "hint": "(ان سب کا انتخاب کریں جو آپ پر صادق آتے ہیں)"
    },
    "environment": {
      "title": "آج آپ کا ماحول",
      "hint": "اپنے گرد و پیش کو سمجھنے میں ہماری مدد کریں"
    },
    "basicChecks": {
      "title": "فوری بنیادی جائزے",
      "hint": "اختیاری لیکن مددگار"
    },
    "validation": {
      "pickOne": "براہ کرم کم از کم ایک سوال کا جواب دیں"
    },
    "submit": {
      "cta": "میری صحت کی معلومات حاصل کریں",
      "saving": "محفوظ ہو رہا ہے...",
      "analyzing": "آپ کی صحت کے رجحانات کا جائزہ لیا جا رہا ہے...",
      "savedToast": "✅ جائزہ محفوظ کر لیا گیا! آپ کی صحت کے رجحانات کا جائزہ لیا جا رہا ہے..."
    }
  },
  "stepTracker": {
    "header": {
      "title": "قدموں کا ٹریکر",
      "subtitle": "آپ کی سرگرمیوں کا ایماندارانہ ریکارڈ",
      "backToDashboard": "ڈیش بورڈ پر واپس جائیں"
    },
    "today": {
      "title": "آج کے قدم",
      "goalProgress": "{{current}} / {{goal}} قدم",
      "goalReached": "ہدف مکمل ہو گیا — بہت اچھے!",
      "keepGoing": "جاری رکھیں — آپ صحیح سمت میں جا رہے ہیں۔"
    },
    "streak": {
      "label": "موجودہ تسلسل",
      "days": "{{count}} دن",
      "daysPlural": "{{count}} دن"
    },
    "badges": {
      "title": "تمغے",
      "empty": "جیسے جیسے آپ عادت بنائیں گے، آپ تمغے جیتیں گے۔"
    },
    "reminders": {
      "title": "حرکت کی یاد دہانی",
      "hint": "زیادہ دیر بیٹھے رہنے کی صورت میں مختصر چہل قدمی کی ہلکی سی یاد دہانی۔",
      "enabled": "فعال",
      "disabled": "غیر فعال"
    },
    "insights": {
      "weeklyAverage": "ہفتہ وار اوسط",
      "weeklyGoal": "ہفتہ وار ہدف"
    },
    "actions": {
      "connect": "قدم گننے کا ذریعہ منسلک کریں",
      "manualLog": "خود سے قدم درج کریں",
      "changeGoal": "روزانہ کا ہدف تبدیل کریں"
    }
  },
  "checkin": {
    "header": {
      "title": "روزانہ کی صحت کا جائزہ",
      "subtitle": "صرف 60 سیکنڈ سے بھی کم وقت لگے گا",
      "restDayLink": "آج میرا موڈ نہیں ہے"
    },
    "snapshot": {
      "title": "آپ کا ڈیش بورڈ اپ ڈیٹ ہو گیا ہے",
      "healthScore": "صحت کا اسکور",
      "todayTasks": "آج کے کام",
      "dayStreak": "دنوں کا تسلسل"
    },
    "resume": {
      "banner": "وہیں سے شروع کریں جہاں چھوڑا تھا",
      "startFresh": "نئے سرے سے شروع کریں",
      "dismiss": "ختم کریں"
    },
    "progress": {
      "allSet": "سب تیار ہے",
      "step": "مرحلہ {{current}} از {{total}}",
      "ariaLabel": "روزانہ کا جائزہ: {{total}} میں سے {{done}} حصے مکمل"
    },
    "insights": {
      "title": "آپ کی صحت کی معلومات",
      "subtitle": "آج کے لیے آپ کی ضرورت کے مطابق",
      "insightForYou": "آپ کے لیے خاص معلومات",
      "simpleActions": "سادہ اقدامات جو آپ کر سکتے ہیں",
      "whenToSeekHelp": "رہنمائی کب حاصل کریں",
      "nhsAdvice": "پریشانی کی صورت میں NHS 111 یا اپنے ڈاکٹر سے رابطہ کریں",
      "backToDashboard": "ڈیش بورڈ پر واپس جائیں",
      "newCheckIn": "نیا جائزہ",
      "disclaimer": "HealthLoop صرف رہنمائی فراہم کرتا ہے، طبی تشخیص نہیں۔"
    },
    "restDay": {
      "title": "آرام بھی زندگی کی روانی کا حصہ ہے۔",
      "body": "جب آپ تیار ہوں گے، ہم کل یہیں ملیں گے۔",
      "streakNote": "آپ کا تسلسل ٹوٹا نہیں ہے — یہ بھی بس آرام کر رہا ہے۔",
      "backToDashboard": "ڈیش بورڈ پر واپس جائیں",
      "changedMind": "دراصل، میں جائزہ لینا چاہوں گا۔"
    },
    "feelings": {
      "title": "آج آپ کیسا محسوس کر رہے ہیں؟",
      "hint": "ان سب کا انتخاب کریں جو آپ پر صادق آتے ہیں",
      "tired": "تھکن محسوس ہو رہی ہے",
      "headache": "سر میں درد",
      "stressed": "ذہنی دباؤ یا بوجھ",
      "pain": "جسم میں درد",
      "okay": "میں آج ٹھیک محسوس کر رہا ہوں"
    },
    "basics": {
      "title": "آپ کی بنیادی معلومات",
      "sleepQ": "کیا آپ کل رات سکون سے سوئے؟",
      "waterQ": "کیا آپ نے آج مناسب مقدار میں پانی پیا؟",
      "foodQ": "کیا آپ نے آج صحیح طریقے سے کھانا کھایا؟",
      "activityQ": "آج آپ کتنے متحرک رہے؟",
      "yes": "جی ہاں",
      "notReally": "زیادہ نہیں",
      "notYet": "ابھی تک نہیں",
      "notActive": "متحرک نہیں",
      "lightActivity": "ہلکی پھلکی سرگرمی",
      "active": "متحرک"
    },
    "mind": {
      "title": "ذہن اور توانائی",
      "stressQ": "آج آپ کے تناؤ کی سطح کیا ہے؟",
      "moodQ": "آج آپ کا موڈ کیسا ہے؟",
      "energyQ": "آج آپ کی توانائی کی سطح کیسی ہے؟",
      "low": "کم",
      "moderate": "درمیانی",
      "high": "زیادہ",
      "neutral": "عام سا",
      "good": "اچھا",
      "okay": "ٹھیک"
    },
    "day": {
      "title": "آپ کا دن",
      "routineQ": "کیا آپ نے آج اپنے معمولات پر عمل کیا؟",
      "yes": "جی ہاں",
      "no": "جی نہیں"
    },
    "environment": {
      "title": "آج آپ کا ماحول",
      "describeQ": "آپ اپنے ماحول کو کیسے بیان کریں گے؟",
      "comfortable": "😊 آرام دہ",
      "slightlyUncomfortable": "😐 تھوڑا سا بے چین",
      "challenging": "😓 مشکل",
      "affectedQ": "کیا آپ کے گرد و پیش نے آپ کے احساسات پر اثر ڈالا؟",
      "yes": "جی ہاں",
      "no": "جی نہیں",
      "exposureLabel": "اثرات (ان سب کا انتخاب کریں جو آپ نے محسوس کیے)",
      "heat": "🌡️ گرمی",
      "cold": "❄️ سردی",
      "noise": "🔊 شور",
      "dustSmoke": "💨 گرد یا دھواں",
      "crowded": "👥 ہجوم والی جگہ",
      "none": "✅ کوئی نہیں"
    },
    "submit": {
      "analyzing": "آپ کی صحت کے رجحانات کا جائزہ لیا جا رہا ہے...",
      "cta": "میری صحت کی معلومات دیکھیں"
    },
    "toast": {
      "savedFull": "جائزہ محفوظ کر لیا گیا! آپ کا ڈیش بورڈ اپ ڈیٹ ہو گیا ہے۔",
      "savedShort": "جائزہ محفوظ کر لیا گیا۔"
    }
  },
  "onboarding": {
    "welcome": "خوش آمدید",
    "completeSetup": "سیٹ اپ مکمل کریں",
    "stepProgress": "مرحلہ {{step}} از {{total}}",
    "percentComplete": "{{percent}}% مکمل",
    "welcomeToast": "HealthLoop میں خوش آمدید! آپ کا پروفائل تیار ہے۔",
    "errorAgeRange": "براہ کرم اپنی عمر کی حد منتخب کریں",
    "errorCountry": "براہ کرم اپنا ملک منتخب کریں",
    "errorGoal": "براہ کرم صحت کا بنیادی ہدف منتخب کریں",
    "errorCuisine": "براہ کرم کم از کم ایک پسندیدہ کھانے کا انتخاب کریں",
    "errorGeneric": "سیٹ اپ مکمل کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
    "step1Title": "HealthLoop میں خوش آمدید! 👋",
    "step1Subtitle": "آئیے آپ کی صحت کے سفر کو بہتر بنائیں",
    "ageRangeLabel": "آپ کی عمر کیا ہے؟",
    "genderLabel": "جنس (اختیاری)",
    "gender_male": "مرد",
    "gender_female": "خاتون",
    "gender_non-binary": "نان بائنری",
    "gender_prefer_not_to_say": "بتانا پسند نہیں",
    "step2Title": "آپ کا تعلق کہاں سے ہے؟ 🌍",
    "step2Subtitle": "اس سے ہمیں آپ کی ثقافت کے مطابق کھانے تجویز کرنے میں مدد ملتی ہے",
    "countryLabel": "اپنا ملک منتخب کریں",
    "country_uk": "برطانیہ",
    "country_nigeria": "نائجیریا",
    "country_ghana": "گھانا",
    "country_kenya": "کینیا",
    "country_south_africa": "جنوبی افریقہ",
    "country_usa": "امریکہ",
    "country_canada": "کینیڈا",
    "country_india": "بھارت",
    "country_jamaica": "جمیکا",
    "country_other": "دیگر",
    "step3Title": "آپ کا اصل ہدف کیا ہے؟ 🎯",
    "step3Subtitle": "صحت کا اپنا بنیادی مقصد منتخب کریں",
    "additionalGoals": "کوئی اور اہداف؟ (اختیاری)",
    "goal_weight_loss": "وزن کم کرنا",
    "goalDesc_weight_loss": "صحت مند طریقے سے وزن کم کریں",
    "goal_weight_maintenance": "وزن برقرار رکھنا",
    "goalDesc_weight_maintenance": "موجودہ وزن پر قائم رہیں",
    "goal_muscle_gain": "پٹھے بنانا",
    "goalDesc_muscle_gain": "قوت اور پٹھے بڑھائیں",
    "goal_general_wellness": "عام تندرستی",
    "goalDesc_general_wellness": "مجموعی صحت میں بہتری",
    "goal_better_sleep": "بہتر نیند",
    "goalDesc_better_sleep": "نیند کے معیار کو بہتر بنائیں",
    "goal_reduce_stress": "ذہنی دباؤ میں کمی",
    "goalDesc_reduce_stress": "تناؤ کو بہتر طریقے سے سنبھالیں",
    "goal_increase_energy": "توانائی میں اضافہ",
    "goalDesc_increase_energy": "زیادہ توانا محسوس کریں",
    "step4Title": "کھانے کی ترجیحات 🍽️",
    "step4Subtitle": "اپنی پسند کے کھانے اور کسی بھی پرہیز کا انتخاب کریں",
    "cuisineLabel": "پسندیدہ کھانے",
    "cuisineHint": "کم از کم ایک منتخب کریں (آپ ایک سے زیادہ بھی چن سکتے ہیں)",
    "dietaryLabel": "غذائی پابندیاں / پرہیز (اختیاری)",
    "diet_vegetarian": "سبزی خور (Vegetarian)",
    "diet_vegan": "ویگن (Vegan)",
    "diet_halal": "حلال",
    "diet_kosher": "کوشر",
    "diet_gluten_free": "گلوٹین سے پاک",
    "diet_dairy_free": "ڈیری سے پاک",
    "diet_pescatarian": "پیسکاٹیرین",
    "step5Title": "صحت کی صورتحال 🏥",
    "step5Subtitle": "اختیاری — اس سے ہمیں بہتر رہنمائی فراہم کرنے میں مدد ملتی ہے",
    "conditionsLabel": "کیا آپ کو ان میں سے کوئی بیماری ہے؟",
    "conditionsHint": "یہ معلومات نجی ہیں اور آپ کے تجربے کو بہتر بنانے کے لیے استعمال ہوتی ہیں",
    "condition_diabetes": "ذیابیطس",
    "condition_hypertension": "بلڈ پریشر",
    "condition_heart_disease": "دل کی بیماری",
    "condition_thyroid": "تھائیرائڈ کے مسائل",
    "condition_celiac": "سیلیک بیماری",
    "condition_ibs": "آئی بی ایس (IBS)",
    "condition_none": "کوئی نہیں",
    "privacyTitle": "آپ کا ڈیٹا محفوظ ہے",
    "privacyBody": "آپ کی ذاتی معلومات کو محفوظ طریقے سے رکھا جاتا ہے۔ ہم یہ ڈیٹا صرف آپ کے لیے موزوں کھانے، صحت کے مشوروں اور اطلاعات کے لیے استعمال کرتے ہیں۔ آپ کی اجازت کے بغیر آپ کا ڈیٹا کبھی کسی سے شیئر نہیں کیا جائے گا۔",
    "trackMedication": "میں اپنی ادویات کا ریکارڈ رکھنا چاہتا ہوں",
    "specialistInterest": "میں ماہرین سے مشورے میں دلچسپی رکھتا ہوں",
    "welcomeTitle": "HealthLoop میں خوش آمدید! 👋",
    "welcomeSubtitle": "آئیے چند آسان مراحل میں آپ کی AI سے لیس بچاؤ کی صحت اور طرز زندگی کو ذاتی بنائیں۔",
    "stepLabel": "مرحلہ {{current}} از {{total}}",
    "skipForNow": "ابھی چھوڑ دیں",
    "skipToast": "آپ اپنی پروفائل سے کسی بھی وقت آن بورڈنگ مکمل کر سکتے ہیں",
    "back": "پیچھے",
    "next": "آگے",
    "completing": "مکمل ہو رہا ہے...",
    "complete": "سیٹ اپ مکمل کریں",
    "successToast": "HealthLoop میں خوش آمدید! اب آپ کی پروفائل آپ کے مطابق بنا دی گئی ہے 🎉",
    "failureToast": "آن بورڈنگ مکمل کرنے میں ناکامی ہوئی",
    "validation": {
      "basicInfo": "براہ کرم تمام بنیادی معلومات فراہم کریں",
      "pickGoal": "براہ کرم کم از کم ایک صحت کا ہدف منتخب کریں",
      "pickPrimary": "براہ کرم اپنا بنیادی ہدف منتخب کریں",
      "pickRegion": "کھانے کی بہتر تجاویز کے لیے براہ کرم اپنا ثقافتی خطہ منتخب کریں",
      "pickFocus": "براہ کرم اپنی فلاح و بہبود کا بنیادی مرکز منتخب کریں"
    },
    "step1": {
      "title": "آپ کی صحت کی پروفائل",
      "description": "اپنی ذاتی AI صحت کی معلومات تیار کرنے میں ہماری مدد کریں",
      "age": "عمر *",
      "agePlaceholder": "مثلاً 30",
      "height": "قد (سینٹی میٹر) *",
      "heightPlaceholder": "مثلاً 170",
      "weight": "وزن (کلوگرام) *",
      "weightPlaceholder": "مثلاً 70"
    },
    "step2": {
      "title": "آپ کی صحت کے اہداف",
      "description": "تمام متعلقہ انتخاب کریں، پھر اپنا بنیادی ہدف منتخب کریں",
      "primaryLabel": "اپنا بنیادی ہدف منتخب کریں *",
      "primaryBadge": "بنیادی"
    },
    "step3": {
      "title": "🌍 ثقافتی اور غذائی ترجیحات",
      "description": "کھانے کی تجاویز کو آپ کے مطابق بنانے میں ہماری مدد کریں",
      "regionLabel": "ثقافتی خطہ *",
      "regionHint": "ذاتی نوعیت کے کھانے کی تجاویز کے لیے اپنا ثقافتی پس منظر منتخب کریں",
      "countryLabel": "ملک (اختیاری)",
      "countryPlaceholder": "مثلاً نائیجیریا، کینیا، جمیکا",
      "countryHint": "مزید بہتر اور ذاتی تجاویز کے لیے",
      "foodPrefLabel": "کھانوں کے تنوع کی ترجیح"
    },
    "step4": {
      "title": "فلاح و بہبود کا بنیادی مرکز",
      "description": "اس شعبے کا انتخاب کریں جس پر آپ سب سے زیادہ توجہ دینا چاہتے ہیں"
    },
    "step5": {
      "title": "آپ کی ترجیحات",
      "description": "اپنے HealthLoop تجربے کو اپنی مرضی کے مطابق بنائیں",
      "trackMeds": "ادویات کا ریکارڈ رکھیں",
      "trackMedsHint": "اپنے روزانہ کے چیک ان میں ادویات کی ٹریکنگ اور یاد دہانیوں کو فعال کریں",
      "specialist": "ماہرین کی مدد میں دلچسپی",
      "specialistHint": "فلاح و بہبود کے ماہرین، غذائی ماہرین، اور ذہنی صحت کے پیشہ ور افراد تک رسائی حاصل کریں",
      "confidentialTitle": "خفیہ مدد:",
      "confidentialBody": "آپ کی تمام معلومات محفوظ ہیں اور صرف ذاتی بچاؤ کی صحت کی معلومات فراہم کرنے کے لیے استعمال کی جاتی ہیں۔"
    },
    "step6": {
      "title": "کھانے کی تخصیص",
      "description": "ہمیں ایسے کھانوں کی سفارش کرنے میں مدد کریں جو آپ کے ذائقے اور غذائی ضروریات کے مطابق ہوں",
      "cuisinesLabel": "پسندیدہ پکوان (اختیاری)",
      "cuisinesHint": "ان پکوانوں کا انتخاب کریں جن سے آپ سب سے زیادہ لطف اندوز ہوتے ہیں",
      "dietaryLabel": "غذائی پابندیاں (اختیاری)",
      "dietaryHint": "جو بھی آپ پر لاگو ہوں انہیں منتخب کریں",
      "allergiesLabel": "عام الرجی (اختیاری)",
      "allergiesHint": "کسی بھی قسم کی غذائی الرجی منتخب کریں",
      "personalisedTitle": "ذاتی نوعیت کے کھانے:",
      "personalisedBody": "ہم ان ترجیحات کو ایسے کھانوں کی سفارش کرنے کے لیے استعمال کریں گے جو آپ کے ذائقے اور ضروریات کے مطابق ہوں۔ آپ ان کو بعد میں سیٹنگز میں تبدیل کر سکتے ہیں۔"
    },
    "healthGoals": {
      "better_sleep": "بہتر نیند",
      "reduce_stress": "تناؤ میں کمی",
      "increase_energy": "توانائی میں اضافہ",
      "weight_management": "وزن کا انتظام",
      "improve_fitness": "فٹنس میں بہتری",
      "better_nutrition": "بہتر غذائیت",
      "mental_wellness": "ذہنی سکون",
      "chronic_condition": "صحت کا انتظام"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "ذہنی صحت",
        "description": "موڈ، تناؤ اور جذباتی بہتری پر توجہ دیں"
      },
      "physical_fitness": {
        "label": "جسمانی فٹنس",
        "description": "ورزش، طاقت اور سرگرمی پر توجہ دیں"
      },
      "nutrition": {
        "label": "غذائیت",
        "description": "خوراک، کھانوں اور صحت بخش کھانے پر توجہ دیں"
      },
      "sleep": {
        "label": "نیند کا معیار",
        "description": "آرام، نیند کے معمولات اور بحالی پر توجہ دیں"
      },
      "stress_management": {
        "label": "تناؤ کا انتظام",
        "description": "پرسکون رہنے اور تناؤ کم کرنے پر توجہ دیں"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "مغربی افریقی",
        "description": "نائیجیرین، گھاناین، سینیگالی پکوان"
      },
      "east_african": {
        "label": "مشرقی افریقی",
        "description": "کینیا، ایتھوپیا، تنزانیہ کے پکوان"
      },
      "north_african": {
        "label": "شمالی افریقی",
        "description": "مراکشی، مصری پکوان"
      },
      "southern_african": {
        "label": "جنوبی افریقی",
        "description": "جنوبی افریقی پکوان"
      },
      "caribbean": {
        "label": "کیریبین",
        "description": "جمائیکن، ٹرینیڈاڈین، باربیڈین پکوان"
      },
      "middle_eastern": {
        "label": "مشرق وسطیٰ",
        "description": "لبنانی، فلسطینی، شامی پکوان"
      },
      "south_asian": {
        "label": "جنوبی ایشیائی",
        "description": "پاکستانی، ہندوستانی، بنگلہ دیشی پکوان"
      },
      "east_asian": {
        "label": "مشرقی ایشیائی",
        "description": "چینی، جاپانی، کوریائی پکوان"
      },
      "southeast_asian": {
        "label": "جنوب مشرقی ایشیائی",
        "description": "تھائی، ویتنامی، انڈونیشیائی پکوان"
      },
      "western": {
        "label": "مغربی",
        "description": "امریکی، یورپی پکوان"
      },
      "latin_american": {
        "label": "لاطینی امریکی",
        "description": "میکسیکن، برازیلی، ارجنٹائنی پکوان"
      },
      "mediterranean": {
        "label": "بحیرہ روم",
        "description": "یونانی، اطالوی، ہسپانوی پکوان"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "روایتی",
        "description": "زیادہ تر آپ کے ثقافتی خطے کے کھانے"
      },
      "mixed": {
        "label": "مخلوط",
        "description": "مقامی اور بین الاقوامی کھانوں کا توازن"
      },
      "international": {
        "label": "بین الاقوامی",
        "description": "متنوع عالمی پکوان"
      }
    },
    "cuisines": {
      "west_african": "مغربی افریقی",
      "caribbean": "کیریبین",
      "mediterranean": "بحیرہ روم",
      "asian": "ایشیائی",
      "western": "مغربی",
      "indian": "ہندوستانی",
      "middle_eastern": "مشرق وسطیٰ",
      "general": "تمام پکوان"
    },
    "dietary": {
      "vegetarian": "سبزی خور",
      "vegan": "ویگن",
      "pescatarian": "پیسکیٹیرین",
      "gluten_free": "گلوٹین فری",
      "dairy_free": "دودھ سے پاک",
      "low_carb": "کم کاربوہائیڈریٹ"
    },
    "allergies": {
      "nuts": "میوے",
      "shellfish": "شیل فش",
      "dairy": "دودھ کی مصنوعات",
      "eggs": "انڈے",
      "soy": "سویا",
      "gluten": "گلوٹین"
    },
    "cuisine_nigerian": "نائیجیریائی",
    "cuisine_ghanaian": "گھانائی",
    "cuisine_senegalese": "سینیگالی",
    "cuisine_kenyan": "کینیائی",
    "cuisine_ethiopian": "ایتھوپیائی",
    "cuisine_moroccan": "مراکشی",
    "cuisine_south_african": "جنوبی افریقی",
    "cuisine_jamaican": "جمائیکی",
    "cuisine_trinidadian": "ٹرینیڈاڈی",
    "cuisine_lebanese": "لبنانی",
    "cuisine_turkish": "ترک",
    "cuisine_greek": "یونانی",
    "cuisine_italian": "اطالوی",
    "cuisine_french": "فرانسیسی",
    "cuisine_british": "برطانوی",
    "cuisine_indian_south": "جنوبی ہندوستانی",
    "cuisine_indian_north": "شمالی ہندوستانی",
    "cuisine_pakistani": "پاکستانی",
    "cuisine_japanese": "جاپانی",
    "cuisine_chinese": "چینی",
    "cuisine_korean": "کوریائی",
    "cuisine_vietnamese": "ویتنامی",
    "cuisine_thai": "تھائی",
    "cuisine_filipino": "فلپائنی",
    "cuisine_american": "امریکی",
    "cuisine_mexican": "میکسیکی",
    "cuisine_brazilian": "برازیلی",
    "cuisine_peruvian": "پیروویائی"
  },
  "dashboard": {
    "welcome": "خوش آمدید",
    "greeting": "ہیلو",
    "goodMorning": "صبح بخیر",
    "goodAfternoon": "سہ پہر بخیر",
    "goodEvening": "شام بخیر",
    "tagline": "چھوٹے صحت مند قدم مستقل تبدیلی لاتے ہیں",
    "microcopy": "آپ کی تندرستی کا سفر اہم ہے۔",
    "welcomeSubtitleMorning1": "دن کا پرسکون آغاز۔",
    "welcomeSubtitleMorning2": "خوشی ہوئی کہ آپ صبح کے وقت یہاں آئے۔",
    "welcomeSubtitleMorning3": "چھوٹے لمحات بڑے فرق لاتے ہیں۔",
    "welcomeSubtitleAfternoon1": "امید ہے کہ آپ کا دن اچھا گزر رہا ہوگا۔",
    "welcomeSubtitleAfternoon2": "HealthLoop میں دوبارہ خوش آمدید۔",
    "welcomeSubtitleAfternoon3": "ایک گہرا سانس لیں — آپ اچھا کام کر رہے ہیں۔",
    "welcomeSubtitleEvening1": "دن کا اختتام سکون کے ساتھ۔",
    "welcomeSubtitleEvening2": "دن کا ایک نرم اختتام۔",
    "welcomeSubtitleEvening3": "شام کے وقت دوبارہ خوش آمدید۔",
    "title": "آپ کا حفاظتی صحت کا ذہین پلیٹ فارم",
    "subtitle": "مسائل بڑھنے سے پہلے ان کا سراغ لگائیں، سیکھیں اور عمل کریں",
    "summary": "آپ کی ہیلتھ انٹیلیجنس کا خلاصہ",
    "summaryDesc": "بیماریوں سے بچاؤ، تعلیم اور تندرستی کے بارے میں تازہ معلومات",
    "comprehensiveSupport": "بیماریوں سے بچاؤ، تعلیم اور تندرستی کے لیے مکمل رہنمائی",
    "todayCheckIn": "آج کا چیک ان",
    "quickActions": "فوری ایکشن",
    "healthOverview": "صحت کا جائزہ",
    "recentActivity": "حالیہ سرگرمی",
    "viewAll": "سب دیکھیں",
    "preventiveHealth": "حفاظتی صحت",
    "preventiveHealthDesc": "روزانہ کا ریکارڈ اور حفاظتی انتباہات",
    "education": "تعلیم",
    "educationDesc": "صحت کے مضامین اور ماہرین کی رہنمائی",
    "engagement": "سرگرمیاں",
    "engagementDesc": "کمیونٹی چیلنجز اور اچھی عادتوں کا سراغ",
    "wellness": "تندرستی",
    "wellnessDesc": "ذہین غذائیت اور طرز زندگی کا توازن",
    "todaysInsight": "آج کی خاص بات",
    "wellnessScore": "تندرستی کا سکور",
    "healthStreak": "صحت کا تسلسل",
    "days": "دن",
    "logHealth": "صحت کا ریکارڈ رکھیں",
    "getEducated": "تعلیم حاصل کریں",
    "communityChallenge": "کمیونٹی چیلنج",
    "checkWellness": "تندرستی چیک کریں",
    "verified": "تصدیق شدہ",
    "joinCommunity": "کمیونٹی میں شامل ہوں",
    "personalizedPlan": "ذاتی منصوبہ",
    "score": "سکور",
    "checkIns": "چیک انز",
    "habits": "عادتیں",
    "preventive": "حفاظتی",
    "healthMetrics": "صحت کے پیمانے",
    "trackMetrics": "ریکارڈ چیک کریں",
    "startTracking": "ریکارڈ رکھنا شروع کریں",
    "logMetrics": "پیمانے درج کریں",
    "dailyInsight": "روزانہ کی معلومات",
    "learnAbout": "آج حفاظتی صحت کے بارے میں جانیں",
    "articlesAvailable": "دستیاب مضامین",
    "browseArticles": "مضامین دیکھیں",
    "currentStreak": "موجودہ تسلسل",
    "keepGoing": "اسے جاری رکھیں!",
    "startStreak": "اپنا تسلسل شروع کریں",
    "checkIn": "چیک ان",
    "nutritionPlan": "غذائیت کا منصوبہ",
    "mealsPlanned": "کھانے پلان کیے گئے",
    "viewPlan": "منصوبہ دیکھیں",
    "planYourWeek": "اپنے ہفتے کی منصوبہ بندی کریں",
    "moodStress": "مزاج اور تناؤ",
    "howFeeling": "آپ کیسا محسوس کر رہے ہیں؟",
    "logWellness": "تندرستی کا ریکارڈ رکھیں",
    "medications": "ادویات",
    "noMeds": "کوئی دوا ریکارڈ نہیں کی گئی",
    "addMedications": "اپنی ادویات شامل کریں",
    "daysTracked": "ریکارڈ کیے گئے دن",
    "noHabits": "ابھی تک کوئی عادت شامل نہیں",
    "startTrackingHabits": "عادات کا سراغ لگانا شروع کریں",
    "insights": "معلومات",
    "noInsights": "ابھی کوئی معلومات نہیں",
    "completeFirstPlan": "اپنا پہلا منصوبہ مکمل کریں",
    "noCheckIns": "ابھی تک کوئی چیک ان نہیں ہوا",
    "startFirstCheckIn": "پہلا چیک ان کریں"
  },
  "support": {
    "title": "سپورٹ",
    "subtitle": "جوابات تلاش کریں، ہم سے رابطہ کریں یا مسئلہ رپورٹ کریں",
    "backToSettings": "ترتیبات پر واپس جائیں",
    "privacyBanner": "سپورٹ کی درخواستیں نجی اور محفوظ طریقے سے حل کی جاتی ہیں۔ آپ کی صحت کی معلومات خفیہ رہتی ہیں۔",
    "section1": "سیکشن 1",
    "section2": "سیکشن 2",
    "section3": "سیکشن 3",
    "section4": "سیکشن 4",
    "navHelpCenter": "ہیلپ سینٹر",
    "navContact": "سپورٹ سے رابطہ کریں",
    "navHealth": "صحت کی خدمات",
    "navTechnical": "تکنیکی سپورٹ",
    "helpCenterTitle": "ہیلپ سینٹر",
    "helpCenterSubtitle": "عام سوالات تلاش کریں اور فوری جوابات حاصل کریں۔",
    "contactTitle": "سپورٹ سے رابطہ کریں",
    "contactSubtitle": "اپنی پسند کے ذریعے ہماری ٹیم تک پہنچیں۔",
    "healthServicesTitle": "صحت کی خدمات",
    "healthServicesSubtitle": "ادویات کے ریکارڈ اور کلینیکل ماہرین سے رابطہ کریں۔",
    "technicalTitle": "تکنیکی سپورٹ",
    "technicalSubtitle": "تکنیکی خرابیوں یا مسائل کی رپورٹ کریں۔",
    "searchPlaceholder": "عام سوالات تلاش کریں…",
    "liveChat": "لائیو چیٹ",
    "emailUs": "ہمیں ای میل کریں",
    "callBack": "کال بیک کا وقت طے کریں",
    "sendMessage": "پیغام بھیجیں",
    "medicationTracking": "ادویات کا ریکارڈ",
    "specialistAccess": "ماہرین تک رسائی",
    "videoConsultation": "ویڈیو مشورہ",
    "reportBug": "خرابی رپورٹ کریں",
    "yourName": "آپ کا نام",
    "yourEmail": "آپ کا ای میل",
    "subject": "موضوع",
    "message": "پیغام",
    "phone": "فون",
    "description": "تفصیل",
    "submit": "جمع کرائیں",
    "successTitle": "پیغام بھیج دیا گیا",
    "successDescription": "ہم 24 سے 48 گھنٹوں میں جواب دیں گے۔",
    "healthDisclaimer": "طبی ہنگامی صورتحال کے لیے، مقامی ایمرجنسی سروسز سے رابطہ کریں۔ HealthLoop پیشہ ورانہ طبی علاج کا متبادل نہیں ہے۔"
  },
  "nutrition": {
    "smartNutrition": "ذہین غذائیت",
    "basedOnGoal": "آپ کے ہدف کے مطابق:",
    "personalizedData": "آپ کی صحت کے حالیہ ڈیٹا کی بنیاد پر تیار کردہ",
    "evidenceBased": "آپ کے حفاظتی صحت کے منصوبے کے تحت مستند غذائی معلومات",
    "todaysMealSuggestions": "آج کے کھانے کی تجاویز",
    "customize": "اپنی مرضی کے مطابق بنائیں",
    "breakfast": "ناشتہ",
    "lunch": "دوپہر کا کھانا",
    "dinner": "رات کا کھانا",
    "loadingBreakfast": "ناشتہ لوڈ ہو رہا ہے...",
    "loadingLunch": "دوپہر کا کھانا لوڈ ہو رہا ہے...",
    "loadingDinner": "رات کا کھانا لوڈ ہو رہا ہے...",
    "cal": "کیلوریز",
    "protein": "پروٹین",
    "swapMeal": "کھانا تبدیل کریں",
    "healthyOptionsNearYou": "آپ کے قریب صحت بخش انتخاب",
    "enableLocation": "لوکیشن آن کریں",
    "view": "دیکھیں",
    "discoverOptions": "اپنے قریب صحت بخش ریستوراں، گروسری اسٹورز اور کھانے فراہم کرنے والے تلاش کریں",
    "cuisinesSelected": "منتخب کھانے",
    "cuisineSelected": "منتخب کھانا",
    "dietaryPrefs": "غذائی ترجیحات",
    "dietaryPref": "غذائی ترجیح",
    "customizeMeals": "کھانوں کی ترتیب",
    "subtitleAdaptive": "آپ کی ثقافت اور صحت کے اہداف کے مطابق کھانے کی منصوبہ بندی",
    "hideFavorites": "پسندیدہ چھپائیں",
    "viewFavorites": "پسندیدہ دیکھیں",
    "customizeMealsLegacy": "اپنی ثقافتی ترجیحات اور غذائی ضروریات کے مطابق کھانے ترتیب دیں",
    "viewFullPlan": "مکمل منصوبہ دیکھیں",
    "exploreRecipes": "ترکیبیں تلاش کریں"
  },
  "location": {
    "permissionTitle": "اپنے قریب صحت بخش انتخاب تلاش کریں",
    "permissionDesc": "یہ آپ کے صحت کے اہداف کے مطابق ریستوراں اور اسٹورز تجویز کرنے کے لیے استعمال ہوتا ہے۔",
    "howToEnable": "کیسے آن کریں:",
    "step1": "اپنے براؤزر کی ایڈریس بار میں لاک آئیکن 🔒 پر کلک کریں",
    "step2": "\"Location\" کی اجازت تلاش کریں",
    "step3": "اسے \"Allow\" پر تبدیل کریں",
    "step4": "اس صفحے کو ریفریش کریں",
    "refreshPage": "صفحہ ریفریش کریں",
    "allowLocation": "لوکیشن کی اجازت دیں",
    "notNow": "ابھی نہیں",
    "denied": "لوکیشن تک رسائی روک دی گئی ہے۔ قریب ترین آپشنز دیکھنے کے لیے اجازت دینا ضروری ہے۔",
    "unavailable": "لوکیشن کی معلومات فی الحال دستیاب نہیں ہیں۔ براہ کرم آلہ کی ترتیبات چیک کریں۔",
    "error": "آپ کی لوکیشن تک رسائی ممکن نہیں ہے۔ براہ کرم دوبارہ کوشش کریں یا براؤزر کی ترتیبات چیک کریں۔",
    "unsupported": "آپ کا براؤزر لوکیشن سروسز کو سپورٹ نہیں کرتا۔ Chrome یا Safari استعمال کرنے کی کوشش کریں۔",
    "accessRequired": "لوکیشن تک رسائی درکار ہے"
  },
  "womensHealth": {
    "title": "خواتین کی صحت",
    "description": "اپنے سائیکل کا ریکارڈ رکھیں، علامات درج کریں، اور اپنی صحت کے حوالے سے مشورے حاصل کریں",
    "cycleTracking": "سائیکل ٹریکنگ",
    "symptomLogging": "علامات کا اندراج",
    "phaseInsights": "فیز کی معلومات",
    "logPeriod": "پیریڈ درج کریں",
    "logSymptoms": "علامات درج کریں",
    "insights": "معلومات",
    "tips": "صحت کے مشورے",
    "overview": "جائزہ",
    "history": "تاریخچہ",
    "startTracking": "اپنے سائیکل کا ریکارڈ رکھنا شروع کریں"
  },
  "profile": {
    "title": "پروفائل",
    "personalInfo": "ذاتی معلومات",
    "healthProfile": "ہیلتھ پروفائل",
    "preferences": "ترجیحات",
    "language": "زبان",
    "selectLanguage": "زبان منتخب کریں",
    "notifications": "اطلاعات",
    "privacy": "رازداری",
    "security": "سیکیورٹی",
    "quickAccess": "فوری رسائی",
    "editProfile": "پروفائل ایڈٹ کریں",
    "viewStats": "اعداد و شمار دیکھیں",
    "backToDashboard": "ہوم پر واپس جائیں",
    "womensHealthTitle": "خواتین کی صحت",
    "womensHealthDesc": "سائیکل، علامات اور تندرستی کے مشورے",
    "healthRemindersTitle": "صحت کی یاد دہانیاں",
    "healthRemindersDesc": "اپنی اطلاعات کا انتظام کریں",
    "manageRemindersDesc": "یاد دہانیوں اور نوٹیفیکیشنز کو ترتیب دیں",
    "healthPatternAlerts": "آپ کی صحت کے رجحانات کے انتباہات",
    "supportHelp": "سپورٹ اور مدد",
    "supportHelpDesc": "مدد حاصل کریں، مسائل رپورٹ کریں یا سوالات دیکھیں",
    "admin": "ایڈمن",
    "adminDesc": "استعمال کے اعداد و شمار دیکھیں",
    "giveFeedback": "رائے دیں",
    "giveFeedbackDesc": "HealthLoop کے بارے میں اپنا تجربہ شیئر کریں",
    "reportProblem": "مسئلہ رپورٹ کریں",
    "reportProblemDesc": "ایپ کو بہتر بنانے میں ہماری مدد کریں",
    "manageHealthInfo": "ذاتی معلومات کے لیے اپنی حفاظتی صحت کی تفصیلات ترتیب دیں",
    "basicInformation": "بنیادی معلومات",
    "fullName": "پورا نام",
    "email": "ای میل",
    "dateOfBirth": "تاریخ پیدائش",
    "gender": "جنس",
    "height": "قد (سینٹی میٹر)",
    "weight": "وزن (کلوگرام)",
    "medicalConditions": "طبی صورتحال",
    "allergies": "الرجی",
    "personalHealth": "ذاتی صحت",
    "addCondition": "بیماری کی تفصیل شامل کریں",
    "addAllergy": "الرجی شامل کریں",
    "saveChanges": "تبدیلیاں محفوظ کریں",
    "saving": "محفوظ ہو رہا ہے...",
    "privacyMessage": "آپ کی صحت کا ڈیٹا خفیہ اور محفوظ رکھا جاتا ہے"
  },
  "settings": {
    "title": "سیٹنگز",
    "general": "عمومی",
    "account": "اکاؤنٹ",
    "appearance": "ظاہری شکل",
    "languageSettings": "زبان کی ترتیبات",
    "changeLanguage": "زبان تبدیل کریں",
    "languageNote": "جیسے ہی آپ نئی زبان منتخب کرتے ہیں، انٹرفیس اپ ڈیٹ ہو جاتا ہے۔ افریقی اور حال ہی میں شامل کی گئی زبانوں پر 'Starter' کا نشان ہے — یہ وسیع تر رسائی کے لیے مشینی ترجمہ شدہ ہیں اور مقامی ماہرین کی جانچ کے مراحل میں ہیں۔",
    "languageUpdated": "زبان کامیابی سے تبدیل کر دی گئی ہے",
    "starterBadge": "Starter",
    "starterBadgeTooltip": "مشینی ترجمہ — مقامی ماہرین کی نظرِ ثانی باقی ہے۔",
    "regions": {
      "global": "عالمی",
      "european": "یورپی زبانیں",
      "middleEastern": "مشرقِ وسطیٰ کی زبانیں",
      "asian": "ایشیائی زبانیں",
      "african": "افریقی زبانیں"
    }
  },
  "search": {
    "triggerLabel": "HealthLoop میں تلاش کریں",
    "triggerHint": "\"steps\"، \"pharmacy\" یا \"pregnancy\" لکھ کر دیکھیں",
    "triggerAriaLabel": "سرچ کھولیں",
    "placeholder": "فیچرز، ٹریکرز، یا سپورٹ تلاش کریں…",
    "inputAriaLabel": "HealthLoop کے فیچرز تلاش کریں",
    "modalAriaLabel": "HealthLoop میں تلاش کریں",
    "close": "بند کریں",
    "clear": "صاف کریں",
    "clearAriaLabel": "سرچ صاف کریں",
    "recentSearches": "حالیہ تلاش",
    "tryFor": "یہ تلاش کرنے کی کوشش کریں",
    "findFeatures": "کوئی بھی فیچر سیکنڈوں میں تلاش کریں۔",
    "searchAcross": "تلاش کریں",
    "and": "اور",
    "sections": {
      "home": "ہوم",
      "nutrition": "غذائیت",
      "family": "خاندان",
      "services": "سروسز",
      "support": "سپورٹ",
      "profile": "پروفائل"
    },
    "noMatchesFor": "\"{{query}}\" کے لیے کچھ نہیں ملا",
    "trySimpler": "کوئی سادہ لفظ لکھ کر دیکھیں جیسے steps، nutrition یا specialist۔",
    "comingSoonBadge": "جلد آ رہا ہے",
    "escToClose": "بند کرنے کے لیے",
    "resultSingular": "{{count}} نتیجہ",
    "resultPlural": "{{count}} نتائج",
    "searchAcrossApp": "پوری ایپ میں تلاش کریں"
  },
  "familyMember": {
    "confirmRemove": "کیا آپ {{name}} کو فیملی ہیلتھ ٹریکنگ سے ہٹانا چاہتے ہیں؟",
    "removed": "{{name}} کو فیملی سے ہٹا دیا گیا ہے",
    "removeFailed": "ممبر کو ہٹانے میں دشواری ہوئی",
    "viewDetails": "تفصیلات دیکھیں",
    "edit": "ترمیم کریں",
    "remove": "ہٹائیں",
    "yearsSuffix": "سال",
    "healthGoalsLabel": "صحت کے اہداف:",
    "moreSuffix": "مزید",
    "activeInsights": "فعال معلومات",
    "viewAllInsights": "تمام {{count}} معلومات دیکھیں ←",
    "viewFullProfile": "صحت کی مکمل پروفائل دیکھیں",
    "lifeStage": {
      "infant": "شیر خوار (0-2)",
      "toddler": "ننھا بچہ (2-5)",
      "child": "بچہ (6-12)",
      "adolescent": "نوعمر (13-17)",
      "adult": "بالغ (18-59)",
      "senior": "بزرگ (60+)",
      "unknown": "نامعلوم"
    }
  },
  "profileDeep": {
    "backToDashboard": "ڈیش بورڈ پر واپس جائیں",
    "profileCompletion": "پروفائل کی تکمیل",
    "healthSummary": "صحت کا خلاصہ",
    "sectionA": "حصہ الف",
    "sectionB": "حصہ ب",
    "sectionC": "حصہ ج",
    "sectionD": "حصہ د",
    "personalDetails": "ذاتی تفصیلات",
    "healthInformation": "صحت کی معلومات",
    "accountSettings": "اکاؤنٹ کی ترتیبات",
    "fullName": "پورا نام",
    "email": "ای میل",
    "dob": "تاریخِ پیدائش",
    "gender": "جنس",
    "genderPlaceholder": "مثلاً خاتون، مرد، غیر بائنری",
    "height": "قد (cm)",
    "heightPlaceholder": "مثلاً 170",
    "weight": "وزن (kg)",
    "weightPlaceholder": "مثلاً 70",
    "allergies": "الرجی",
    "allergiesPlaceholder": "مثلاً مونگ پھلی",
    "medicalConditions": "طبی کیفیات",
    "conditionsPlaceholder": "مثلاً بلڈ پریشر",
    "medications": "ادویات",
    "medicationsPlaceholder": "مثلاً لیسینوپرل 10mg، روزانہ",
    "emergencyContact": "ہنگامی رابطہ",
    "emergencyOptional": "(اختیاری)",
    "emergencyPlaceholder": "مثلاً امی +1-555-0100",
    "emergencyNote": "یہ معلومات صرف اس صورت میں کلینشین کے ساتھ شیئر کی جائیں گی جب آپ خود منتخب کریں گے۔",
    "saveChanges": "تبدیلیاں محفوظ کریں",
    "saving": "محفوظ ہو رہا ہے…",
    "editProfile": "پروفائل میں ترمیم کریں",
    "cancelEditing": "ترمیم منسوخ کریں",
    "healthScore": "ہیلتھ سکور",
    "streak": "سلسلہ",
    "streakDays": "{{n}} دن",
    "memberSince": "رکنیت کی تاریخ",
    "remindersActive": "یاد دہانیاں فعال ہیں",
    "conditionsTracked": "زیرِ نگرانی کیفیات",
    "nextAgenda": "آپ کے ایجنڈے میں اگلا قدم",
    "notificationsReminders": "اطلاعات اور یاد دہانیاں",
    "notificationsRemindersDesc": "صحت کی یاد دہانیوں کے اوقات اور ذرائع کا انتظام کریں",
    "emailNudges": "ای میل پیغامات",
    "emailNudgesDesc": "نرم یاد دہانیاں اور ہفتہ وار خلاصہ",
    "on": "آن",
    "paused": "موقوف",
    "privacySecurity": "رازداری اور سیکیورٹی",
    "privacySecurityDesc": "اکاؤنٹ کو محفوظ رکھنے کے لیے اپنا پاس ورڈ اپ ڈیٹ کریں",
    "preferencesTitle": "ترجیحات",
    "preferencesDesc": "زبان، علاقہ اور ذاتی ترتیبات",
    "supportHelp": "سپورٹ اور مدد",
    "supportHelpDesc": "جوابات حاصل کریں اور ہم سے رابطہ کریں",
    "giveFeedback": "فیڈ بیک دیں",
    "giveFeedbackDesc": "ہمیں بتائیں کہ کیا بہتر بنایا جا سکتا ہے",
    "reportProblem": "مسئلے کی اطلاع دیں",
    "reportProblemDesc": "کوئی خرابی ملی؟ ہمیں بتائیں",
    "adminInsights": "ایڈمن بصیرت",
    "adminInsightsDesc": "مصروفیات کے تجزیات",
    "adminBadge": "ایڈمن",
    "shareWithClinician": "کلینشین کے ساتھ شیئر کریں",
    "shareWithClinicianDesc": "صرف پڑھنے کے لیے خلاصہ · خودکار طور پر ختم ہونے والا · کسی بھی وقت منسوخ کیا جا سکتا ہے",
    "share": "شیئر کریں",
    "profileMayBeOutOfDate": "پروفائل پرانی ہو سکتی ہے",
    "profileMayBeOutOfDateDesc": "بہتر رہنمائی کے لیے اپنی فلاح و بہبود کا ڈیٹا درست رکھیں — چھوٹی تبدیلیاں (وزن، ادویات) بھی ہمیں آپ کے لیے پیغامات کو بہتر بنانے میں مدد دیتی ہیں۔",
    "updateNow": "ابھی اپ ڈیٹ کریں",
    "profileUpdateError": "آپ کی ترجیح اپ ڈیٹ نہیں ہو سکی۔ براہ کرم دوبارہ کوشش کریں۔",
    "healthLoopUser": "HealthLoop صارف",
    "updatedLabel": "اپ ڈیٹ کر دیا گیا",
    "noEntries": "ابھی تک کوئی اندراج نہیں۔",
    "completionComplete": "آپ کا پروفائل مکمل ہے۔ اب ہم آپ کو بہترین رہنمائی فراہم کر سکتے ہیں۔ 💚",
    "completionAlmostThere": "بس تھوڑا سا رہ گیا ہے۔ چند مزید تفصیلات سے آپ کو بہتر معلومات مل سکیں گی۔",
    "completionInProgress": "بہتر فلاح و بہبود کی بصیرت حاصل کرنے کے لیے اپنا پروفائل مکمل کریں۔",
    "justNow": "ابھی ابھی",
    "minAgo": "{{n}} منٹ پہلے",
    "minsAgo": "{{n}} منٹ پہلے",
    "hourAgo": "{{n}} گھنٹہ پہلے",
    "hoursAgo": "{{n}} گھنٹے پہلے",
    "dayAgo": "{{n}} دن پہلے",
    "daysAgo": "{{n}} دن پہلے",
    "checkinDueToday": "آج کا چیک ان باقی ہے",
    "checkinDueTonight": "آج رات کا چیک ان باقی ہے"
  },
  "supportDeep": {
    "backToSettings": "سیٹنگز پر واپس جائیں",
    "quickNavAria": "سپورٹ کے شعبے",
    "searchPlaceholder": "مدد تلاش کریں…",
    "searchAria": "اکثر پوچھے گئے سوالات تلاش کریں",
    "resultsCount": "{{n}} نتیجہ",
    "resultsCountPlural": "{{n}} نتائج",
    "questionsCount": "{{n}} سوالات",
    "liveChatTitle": "لائیو چیٹ",
    "liveChatDesc": "ہم سے براہِ راست بات کریں · پیر تا جمعہ صبح 9 سے شام 6 بجے تک",
    "startChat": "چیٹ شروع کریں",
    "liveChatSoonToast": "لائیو چیٹ جلد شروع ہو رہی ہے۔ تب تک ای میل بہترین ذریعہ ہے۔",
    "emailUsTitle": "ہمیں ای میل کریں",
    "emailUsDesc": "24 سے 48 گھنٹوں میں جواب",
    "copy": "کاپی کریں",
    "emailCopied": "ای میل کلپ بورڈ پر کاپی کر لی گئی۔",
    "contactFormTitle": "رابطہ فارم",
    "contactFormDesc": "ہمیں پیغام بھیجیں — ہم ای میل کے ذریعے جواب دیں گے۔",
    "yourNameLabel": "آپ کا نام *",
    "namePlaceholder": "نام یہاں لکھیں",
    "yourEmailLabel": "آپ کا ای میل *",
    "emailPlaceholder": "example@email.com",
    "subjectOptional": "موضوع (اختیاری)",
    "subjectPlaceholder": "ہم کیا مدد کر سکتے ہیں؟",
    "messageLabel": "پیغام *",
    "messagePlaceholder": "اپنی ضرورت کے بارے میں تھوڑا سا بتائیں۔",
    "sending": "بھیجا جا رہا ہے…",
    "sendMessage": "پیغام بھیجیں",
    "messageSent": "پیغام بھیج دیا گیا",
    "messageSentDesc": "ہم 24 سے 48 گھنٹوں میں جواب دیں گے۔",
    "callbackTitle": "کال بیک کی درخواست کریں",
    "callbackDesc": "ہم آپ کو آپ کے مناسب وقت پر کال کریں گے۔",
    "phoneLabel": "فون نمبر *",
    "phonePlaceholder": "+92 300 1234567",
    "preferredTimeLabel": "پسندیدہ وقت (اختیاری)",
    "preferredTimePlaceholder": "مثلاً کل دوپہر",
    "reasonLabel": "وجہ (اختیاری)",
    "reasonPlaceholder": "مختصراً بتائیں کہ آپ کیا بات کرنا چاہتے ہیں؟",
    "submitting": "جمع کیا جا رہا ہے…",
    "requestCallback": "کال بیک کی درخواست کریں",
    "callbackRequested": "کال بیک کی درخواست کر دی گئی",
    "callbackRequestedDesc": "ہم 24 گھنٹوں کے اندر رابطہ کریں گے۔",
    "medicationSupport": "ادویات کے لیے سپورٹ",
    "medicationSupportDesc": "نسخوں، ری فلز اور یاد دہانیوں پر نظر رکھیں۔",
    "goToMedications": "ادویات پر جائیں ←",
    "specialistConsultation": "ماہر سے مشورہ",
    "specialistConsultationDesc": "ذاتی صحت کی رہنمائی کے لیے کلینشین سے رابطہ کریں۔",
    "connectExpert": "ماہر سے رابطہ کریں ←",
    "videoConsult": "ویڈیو مشورہ",
    "videoConsultDesc": "کسی ماہر کے ساتھ براہِ راست ویڈیو سیشن بک کریں۔",
    "bookConsultation": "مشورہ بک کریں ←",
    "premium": "پریمیم",
    "healthDisclaimer": "HealthLoop آپ کی روزمرہ کی فلاح و بہبود میں مدد کرتا ہے — یہ ہنگامی طبی علاج کا متبادل نہیں ہے۔ اگر کچھ فوری نوعیت کا ہو تو براہ کرم اپنی مقامی ہنگامی خدمت سے رابطہ کریں۔",
    "categoryLabel": "زمرہ",
    "catBug": "بگ / غلطی",
    "catPerformance": "سست رفتاری",
    "catFeature": "فیچر کام نہیں کر رہا",
    "catUi": "ڈسپلے کا مسئلہ",
    "catOther": "دیگر",
    "issueTitle": "مسئلے کا عنوان *",
    "issueTitlePlaceholder": "مختصر خلاصہ",
    "detailedDescription": "تفصیلی وضاحت *",
    "detailedDescriptionPlaceholder": "کیا ہوا؟ جب یہ ہوا تب آپ کیا کر رہے تھے؟ عمل کے مراحل بتانے سے ہمیں مدد ملتی ہے۔",
    "autoAttachNote": "ڈیوائس اور براؤزر کی معلومات خودکار طور پر منسلک کر دی جاتی ہیں۔",
    "submitReport": "رپورٹ جمع کرائیں",
    "reportSubmitted": "رپورٹ جمع کر دی گئی",
    "reportSubmittedDesc": "ہماری ٹیم اس پر کام کر رہی ہے۔",
    "fillAllFields": "براہ کرم تمام مطلوبہ خانے پُر کریں",
    "problemReportSubmittedToast": "مسئلے کی رپورٹ جمع کر دی گئی۔ ہم اس کا جائزہ لیں گے اور جلد رابطہ کریں گے۔",
    "messageSentToast": "پیغام بھیج دیا گیا۔ ہم 24 سے 48 گھنٹوں میں جواب دیں گے۔",
    "callRequestedToast": "کال کی درخواست موصول ہو گئی۔ ہم 24 گھنٹوں کے اندر رابطہ کریں گے۔",
    "submitFailGeneric": "جمع کرانے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں یا {{email}} پر ای میل کریں۔",
    "submitFailContact": "بھیجنے میں ناکامی۔ براہ کرم براہِ راست {{email}} پر ای میل کریں۔",
    "comingSoon": "جلد آرہا ہے",
    "specialistRoadmapTitle": "ماہر سے بات کریں",
    "specialistRoadmapSubtitle": "انسانی رہنمائی کا عمل جلد شروع ہو رہا ہے۔ یہ تمام سہولیات یہاں دستیاب ہوں گی تاکہ مدد ہمیشہ ایک کلک کی دوری پر ہو۔",
    "talkToSpecialistTitle": "ماہر سے بات کریں",
    "talkToSpecialistDesc": "روزمرہ کے صحت کے سوالات کے لیے لائسنس یافتہ کلینشین کے ساتھ لائیو چیٹ۔",
    "bookSpecialistTitle": "ماہر کے ساتھ بکنگ کریں",
    "bookSpecialistDesc": "اپنے اہداف کے لیے موزوں ماہر کے ساتھ ون ٹو ون سیشن کا وقت طے کریں۔",
    "liveHealthGuidanceTitle": "لائیو صحت کی رہنمائی",
    "liveHealthGuidanceDesc": "علامات، لیبارٹری کے نتائج یا علاج کے منصوبوں کے لیے ویڈیو رہنمائی۔",
    "mentalWellnessTitle": "ذہنی فلاح و بہبود کے لیے سپورٹ",
    "mentalWellnessDesc": "زندگی کے مشکل حالات میں ذہنی صحت کے ماہرین سے خفیہ مدد۔",
    "wellnessNavigationTitle": "فلاح و بہبود کا راستہ",
    "wellnessNavigationDesc": "ایک رہنمائی والا طریقہ جو آپ کو صحیح اگلے قدم کے انتخاب میں مدد دیتا ہے۔",
    "pharmacyRoadmapTitle": "ادویات اور فارمیسی سپورٹ",
    "pharmacyRoadmapSubtitle": "فارمیسی سے متعلق مدد سپورٹ سیکشن میں موجود ہو گی — کوئی اضافی ٹیب سیکھنے کی ضرورت نہیں۔",
    "medicationGuidanceTitle": "ادویات کی رہنمائی",
    "medicationGuidanceDesc": "خوراک، وقت اور ادویات کے باہمی اثرات پر سادہ زبان میں رہنمائی۔",
    "findNearbyPharmacyTitle": "قریبی فارمیسی تلاش کریں",
    "findNearbyPharmacyDesc": "جب آپ کو دوا دوبارہ لینی ہو تو اپنے علاقے میں بھروسہ مند فارمیسیز تلاش کریں۔",
    "refillReminderTitle": "ری فل یاد دہانی کی سپورٹ",
    "refillReminderDesc": "نرم یاد دہانیاں تاکہ آپ کی اہم ادویات کبھی ختم نہ ہوں۔",
    "otcWellnessTitle": "عام ادویات (OTC) کے لیے مشورہ",
    "otcWellnessDesc": "بغیر نسخہ ملنے والی محفوظ ادویات کے بارے میں مستند رہنمائی۔"
  },
  "careServices": {
    "pageTitle": "نگہداشت کی خدمات",
    "pageSubtitle": "آپ کی روزمرہ صحت کے سفر کے لیے تیار کردہ کلینیکل اور ویلنس سپورٹ۔",
    "specialistCareTitle": "ماہرانہ نگہداشت",
    "specialistCareSubtitle": "جب ضرورت ہو کلینشین سے بات کریں اور ماہر کا انتخاب کریں۔",
    "medicationPharmacyTitle": "ادویات اور فارمیسی",
    "medicationPharmacySubtitle": "ادویات کی سادہ زبان میں رہنمائی اور فارمیسی کی مدد۔",
    "wellnessSupportTitle": "ویلنس سپورٹ",
    "wellnessSupportSubtitle": "ذہنی فلاح و بہبود، عام ادویات کی رہنمائی اور واضح اگلا قدم۔",
    "futureWellnessTitle": "مستقبل کے ویلنس فیچرز",
    "futureWellnessSubtitle": "HealthLoop کے حفاظتی فلاح و بہبود کے روڈ میپ کی ایک جھلک۔",
    "futureFeatureBadge": "مستقبل کا فیچر",
    "futurePersonalizedMealsTitle": "ذاتی کھانے کے منصوبے",
    "futurePersonalizedMealsDesc": "آپ کے اہداف، الرجی اور ثقافت کے مطابق تیار کردہ کھانے کے منصوبے۔",
    "futureHealthyDeliveryTitle": "صحت بخش کھانے کی ڈیلیوری",
    "futureHealthyDeliveryDesc": "صحت بخش کچن اور پارٹنرز سے منتخب کھانے کی ڈیلیوری۔",
    "futureFarmFreshTitle": "کھیتوں کی تازہ خوراک",
    "futureFarmFreshDesc": "مقامی فارمز اور تازہ موسمی پیداوار تک براہِ راست رسائی۔",
    "futureFoodPartnershipsTitle": "فوڈ پارٹنرشپس",
    "futureFoodPartnershipsDesc": "صحت بخش کچن، گروسری اسٹورز اور ویلنس برانڈز کے ساتھ تعاون۔",
    "futureNutritionCoachingTitle": "نیوٹریشن کوچنگ",
    "futureNutritionCoachingDesc": "ماہر نیوٹریشن کوچز سے ون ٹو ون رہنمائی۔",
    "futureFamilyWellnessTitle": "خاندانی فلاح و بہبود کے منصوبے",
    "futureFamilyWellnessDesc": "مشترکہ منصوبے جو پورے گھرانے کو صحت مند رکھیں۔",
    "futureWellnessPlusTitle": "Wellness+ ممبرشپ",
    "futureWellnessPlusDesc": "ذاتی رہنمائی، ترجیحی سپورٹ اور گہری بصیرت کے لیے پریمیم درجہ۔",
    "futurePharmacyPartnersTitle": "فارمیسی پارٹنرشپس",
    "futurePharmacyPartnersDesc": "ادویات کی رہنمائی اور ری فلز کے لیے بھروسہ مند فارمیسی روابط۔",
    "futureAdvancedSpecialistTitle": "اعلیٰ ماہرانہ نگہداشت",
    "futureAdvancedSpecialistDesc": "ماہرین تک منظم رسائی، دوسری رائے اور نگہداشت میں رہنمائی۔",
    "futureWellnessMarketplaceTitle": "ویلنس مارکیٹ پلیس",
    "futureWellnessMarketplaceDesc": "معتبر ویلنس مصنوعات اور خدمات کی ایک منتخب جگہ۔",
    "futureVendorCollabTitle": "وینڈر تعاون کا نظام",
    "futureVendorCollabDesc": "صحت بخش خوراک اور ویلنس پارٹنرز کے لیے معیار کی جانچ کا نظام۔"
  },
  "dashboardDeep": {
    "healthProfile": "ہیلتھ پروفائل",
    "notifications": "اطلاعات",
    "familyAccounts": "خاندانی اکاؤنٹس",
    "settings": "سیٹنگز",
    "logout": "لاگ آؤٹ",
    "allCaughtUp": "آپ سب کام مکمل کر چکے ہیں۔",
    "weekInReview": "آپ کے ہفتے کا جائزہ",
    "dismissNotification": "اطلاع ہٹائیں",
    "dismissWeeklyDigest": "ہفتہ وار خلاصہ ہٹائیں",
    "notificationsAria": "اطلاعات",
    "profileMenuAria": "پروفائل مینیو کھولیں",
    "loadingWellness": "آپ کا ویلنس خلاصہ لوڈ ہو رہا ہے",
    "nextTip": "اگلی ٹپ",
    "todayAtGlance": "آج ایک نظر میں",
    "healthScoreLabel": "ہیلتھ سکور",
    "currentStreakLabel": "موجودہ سلسلہ",
    "todaysProgress": "آج کی پیشرفت",
    "insightForYou": "آپ کے لیے خاص بصیرت",
    "checkMyHealthRisk": "میرے صحت کے خطرات چیک کریں",
    "quickAccess": "فوری رسائی",
    "exploreCareServicesTitle": "نگہداشت کی خدمات دریافت کریں",
    "exploreCareServicesSubtitle": "ماہرانہ نگہداشت · فارمیسی · ویلنس — سب ایک جگہ۔",
    "familyCare": "فیملی کیئر",
    "healthLibrary": "ہیلتھ لائبریری",
    "myHealthData": "میرا ہیلتھ ڈیٹا",
    "askQuestion": "سوال پوچھیں",
    "dashLoadError": "ڈیش بورڈ لوڈ نہیں ہو سکا۔ براہ کرم دوبارہ کوشش کریں۔",
    "taskUpdateError": "ٹاسک اپ ڈیٹ نہیں ہو سکا۔ دوبارہ کوشش کریں۔",
    "perfectDay": "بہترین دن! 🎉 آپ کا سلسلہ برقرار رہا۔",
    "letsStart": "آئیں شروع کریں",
    "yourNextStepToday": "آج آپ کا اگلا قدم",
    "completeDailyCheck": "اپنا روزانہ کا ہیلتھ چیک مکمل کریں",
    "startDailyCheck": "روزانہ کا چیک ان شروع کریں",
    "viewAll": "تمام دیکھیں",
    "graceProtected": "سلسلہ محفوظ ہے",
    "todaysHealthRecommendations": "آج کی صحت کی سفارشات",
    "updateViaCheck": "روزانہ چیک کے ذریعے اپ ڈیٹ کریں",
    "healthInsight": "ہیلتھ بصیرت",
    "riskCheckSubtext": "سیکنڈوں میں اپنی صحت کی ذاتی بصیرت حاصل کریں",
    "foodDiet": "خوراک اور غذا",
    "healthScoreNew": "ہیلتھ سکور · نیا",
    "letsBuildScore": "آئیں مل کر آپ کا ہیلتھ سکور بنائیں",
    "oneHealthyHabitAtATime": "ایک وقت میں ایک صحت مند عادت۔",
    "nextCheck": "اگلا چیک ان:",
    "todayAt8pm": "آج رات 8:00 بجے",
    "wellnessTipForYou": "آج کی ویلنس ٹپ · آپ کے لیے",
    "wellnessTipForFactor": "آج کی ویلنس ٹپ · آپ کے {{factor}} کے لیے",
    "logged": "درج کر دیا گیا",
    "gotIt": "سمجھ گیا 👍",
    "gladToSeeYou": "ہمیں آپ کو آج یہاں دیکھ کر خوشی ہوئی 💚",
    "takesLessThan60Sec": "60 سیکنڈ سے بھی کم وقت لگتا ہے",
    "scoreReadyWhenYou": "جب آپ چاہیں تیار ہے",
    "scoreCompleteFirstCheck": "ذاتی بصیرت حاصل کرنے کے لیے اپنا پہلا ویلنس چیک مکمل کریں۔",
    "scoreExcellent": "بہترین",
    "scoreSupportExcellent": "آج آپ کی حالت بہت اچھی ہے۔ اسے برقرار رکھیں۔",
    "scoreGood": "اچھی",
    "scoreSupportGood": "آپ اچھا کر رہے ہیں۔ اپنی صحت مند عادات جاری رکھیں۔",
    "scoreModerate": "درمیانی",
    "scoreSupportModerate": "آپ بہتر ہیں، لیکن چند شعبوں پر توجہ دینے کی ضرورت ہے۔",
    "scoreNeedsAttention": "توجہ طلب",
    "scoreSupportNeedsAttention": "آج آپ کی صحت کو توجہ کی ضرورت ہے۔ چھوٹی تبدیلیاں اسے بہتر بنا سکتی ہیں۔"
  },
  "emailVerify": {
    "bannerWithEmail": "براہ کرم اپنا ای میل ({{email}}) تصدیق کریں تاکہ ہم آپ کا اکاؤنٹ محفوظ رکھ سکیں اور آپ کو روزانہ پیغامات بھیج سکیں۔",
    "bannerNoEmail": "براہ کرم اپنا ای میل تصدیق کریں تاکہ ہم آپ کا اکاؤنٹ محفوظ رکھ سکیں اور آپ کو روزانہ پیغامات بھیج سکیں۔",
    "sending": "بھیجا جا رہا ہے…",
    "resend": "ای میل دوبارہ بھیجیں",
    "sentToast": "تصدیقی ای میل بھیج دی گئی۔ اپنا ان باکس چیک کریں۔",
    "sendFailToast": "تصدیقی ای میل نہیں بھیجی جا سکی۔ بعد میں کوشش کریں۔"
  },
  "forgotPassword": {
    "title": "پاس ورڈ بھول گئے؟",
    "subtitle": "فکر نہ کریں! اپنا ای میل درج کریں اور ہم آپ کو پاس ورڈ تبدیل کرنے کی ہدایات بھیج دیں گے۔",
    "emailLabel": "ای میل ایڈریس",
    "emailPlaceholder": "your.email@example.com",
    "sendResetLink": "ری سیٹ لنک بھیجیں",
    "sending": "بھیجا جا رہا ہے…",
    "backToLogin": "لاگ ان پر واپس جائیں",
    "resendLink": "ای میل دوبارہ بھیجیں",
    "successTitle": "اپنا ای میل چیک کریں",
    "successBody": "اگر {{email}} کے نام سے کوئی اکاؤنٹ موجود ہے، تو ہم نے پاس ورڈ ری سیٹ کا لنک بھیج دیا ہے۔",
    "linkExpires": "یہ لنک 30 منٹ میں ختم ہو جائے گا۔",
    "successToast": "پاس ورڈ کی ہدایات کے لیے اپنا ای میل چیک کریں",
    "errEmptyEmail": "براہ کرم اپنا ای میل ایڈریس درج کریں",
    "errInvalidEmail": "براہ کرم درست ای میل ایڈریس درج کریں",
    "errNetwork": "سرور سے رابطہ نہیں ہو سکا۔ اپنا انٹرنیٹ چیک کریں اور دوبارہ کوشش کریں۔",
    "errGeneric": "ری سیٹ ای میل نہیں بھیجی جا سکی۔ براہ کرم دوبارہ کوشش کریں یا سپورٹ سے رابطہ کریں۔"
  },
  "resetPassword": {
    "title": "نیا پاس ورڈ سیٹ کریں",
    "subtitle": "اپنے اکاؤنٹ کے لیے ایک مضبوط پاس ورڈ بنائیں",
    "newPasswordLabel": "نیا پاس ورڈ",
    "newPasswordPlaceholder": "نیا پاس ورڈ درج کریں",
    "confirmPasswordLabel": "پاس ورڈ کی تصدیق کریں",
    "confirmPasswordPlaceholder": "نئے پاس ورڈ کی تصدیق کریں",
    "requirementsHint": "کم از کم 8 حروف، بشمول بڑے اور چھوٹے حروف اور نمبر",
    "resetPassword": "پاس ورڈ ری سیٹ کریں",
    "resetting": "ری سیٹ ہو رہا ہے…",
    "successTitle": "پاس ورڈ کامیابی سے تبدیل ہو گیا!",
    "successBody": "اب آپ اپنے نئے پاس ورڈ کے ساتھ لاگ ان کر سکتے ہیں۔",
    "successToast": "پاس ورڈ کامیابی سے ری سیٹ ہو گیا!",
    "goToLogin": "لاگ ان پر جائیں",
    "invalidLinkTitle": "لنک درست نہیں ہے",
    "invalidLinkBody": "پاس ورڈ ری سیٹ کرنے کا یہ لنک غلط ہے یا اس کی میعاد ختم ہو چکی ہے۔",
    "requestNewLink": "نئے لنک کی درخواست کریں",
    "showPassword": "پاس ورڈ دکھائیں",
    "hidePassword": "پاس ورڈ چھپائیں",
    "errInvalidLink": "ری سیٹ لنک درست نہیں ہے",
    "errMismatch": "پاس ورڈز آپس میں نہیں مل رہے",
    "errTooShort": "پاس ورڈ کم از کم 8 حروف کا ہونا چاہیے",
    "errExpiredToken": "یہ ری سیٹ لنک ختم ہو چکا ہے یا غلط ہے۔ براہ کرم نئی درخواست کریں۔",
    "errNetwork": "سرور سے رابطہ نہیں ہو سکا۔ اپنا انٹرنیٹ چیک کریں اور دوبارہ کوشش کریں۔",
    "errGeneric": "پاس ورڈ ری سیٹ کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔"
  },
  "tips": {
    "water1": "بیدار ہونے کے 30 منٹ کے اندر پانی پینا جسم میں پانی کی کمی کو دور کرنے اور توانائی بڑھانے میں مدد دیتا ہے۔",
    "water2": "ہر کھانے سے پہلے ایک گلاس پانی پینا پیاس کا احساس ہونے سے پہلے ہی جسم کو ہائیڈریٹ رکھنے کا بہترین طریقہ ہے۔",
    "water3": "پانی میں لیموں کا ایک ٹکڑا یا پودینے کے چند پتے شامل کرنا اسے پینا خوشگوار بنا دیتا ہے۔",
    "meals1": "روزانہ سبزیوں کی ایک اضافی مقدار شامل کرنا آنتوں اور دل کی صحت کے لیے فائدہ مند ہے۔",
    "meals2": "ناشتے میں مٹھی بھر گری دار میوے یا بیج شامل کرنے سے صبح کے وقت آپ کی توانائی برقرار رہتی ہے۔",
    "meals3": "پھلوں کا رس پینے سے بہتر ہے کہ پورا پھل کھائیں — اس کا فائبر خون میں شوگر کی مقدار کو متوازن رکھتا ہے۔",
    "steps1": "کھانے کے بعد 10 منٹ کی واک آپ کے جسم کو شوگر بہتر طریقے سے ہضم کرنے میں مدد دیتی ہے۔",
    "steps2": "صبح کے وقت 5 منٹ کی ورزش تناؤ کو کم کرنے اور آپ کے دن کو پرسکون بنانے میں مددگار ثابت ہو سکتی ہے۔",
    "steps3": "دن میں ایک بار بھی سیڑھیاں چڑھنا ہفتوں میں آپ کے دل کو مضبوط بناتا ہے۔",
    "sleep1": "سونے سے ایک گھنٹہ پہلے لائٹس ہلکی کرنا جسم کو گہری نیند کے لیے تیار کرنے میں مدد دیتا ہے۔",
    "sleep2": "جاگنے کا ایک مستقل وقت — یہاں تک کہ چھٹی کے دن بھی — آپ کی نیند کے چکر کو درست رکھتا ہے۔",
    "sleep3": "صبح کی 10 منٹ کی دھوپ آپ کی نیند کے نظام کو قدرتی طور پر منظم کرنے میں مدد دیتی ہے۔",
    "general1": "دو منٹ تک گہرے سانس لینا تناؤ کو کم کرنے اور توجہ کو بہتر بنانے میں مدد دیتا ہے۔",
    "general2": "آج کسی ایک اچھی بات پر شکر ادا کریں — چھوٹی ذہنی فتوحات مل کر بڑا اثر ڈالتی ہیں۔",
    "general3": "آج آپ نے کوشش کی۔ یہ وہ عادت ہے جو ہر دوسری عادت کو آسان بنا دیتی ہے۔"
  },
  "factors": {
    "hydration": "پانی کی مقدار",
    "nutrition": "غذائیت",
    "movement": "حرکت",
    "sleep": "نیند"
  },
  "nutritionDeep": {
    "mealOptionsLoadFail": "کھانے کے انتخاب لوڈ کرنے میں ناکامی ہوئی",
    "prefsSaved": "کھانے کی ترجیحات محفوظ کر لی گئیں! مینو اپ ڈیٹ ہو رہا ہے...",
    "prefsSaveFail": "ترجیحات محفوظ کرنے میں ناکامی ہوئی",
    "newOptionsFail": "نئے انتخاب لوڈ کرنے میں ناکامی ہوئی",
    "invalidZip": "براہ کرم درست 5 ہندسوں کا زپ کوڈ درج کریں",
    "noVendorsArea": "اس علاقے میں فی الحال کوئی وینڈر دستیاب نہیں ہے۔ ہم اپنی سروس پھیلا رہے ہیں!",
    "vendorsFetchFail": "وینڈرز کی معلومات حاصل کرنے میں ناکامی ہوئی",
    "selectVendorFirst": "براہ کرم پہلے ڈیلیوری وینڈر کا انتخاب کریں",
    "removedFromCart": "کارٹ سے نکال دیا گیا",
    "orderPlaced": "آرڈر کامیابی سے دے دیا گیا ہے! 🎉",
    "enterZipFirst": "براہ کرم پہلے ڈیلیوری سیکشن میں اپنا زپ کوڈ درج کریں",
    "mealNotAvailable": "یہ کھانا ابھی آپ کے علاقے میں ڈیلیوری کے لیے دستیاب نہیں ہے",
    "mealUnavailable": "یہ کھانا فی الحال قریبی وینڈرز کے پاس دستیاب نہیں ہے",
    "vendorOptionsFail": "وینڈر کے انتخاب لوڈ کرنے میں ناکامی ہوئی",
    "favoriteSaveFail": "پسندیدہ میں محفوظ کرنے میں ناکامی ہوئی",
    "removedFromFavorites": "پسندیدہ سے نکال دیا گیا",
    "favoriteRemoveFail": "پسندیدہ سے نکالنے میں ناکامی ہوئی",
    "cartEmpty": "آپ کی کارٹ خالی ہے",
    "noMealOptions": "کھانے کے کوئی انتخاب دستیاب نہیں ہیں",
    "loadingOptions": "کھانے کے انتخاب لوڈ ہو رہے ہیں...",
    "selectPreferences": "اپنے کھانے کی ترجیحات منتخب کریں",
    "mealBuilder": "میل بلڈر",
    "myFavorites": "میرے پسندیدہ",
    "myFavoriteMeals": "میرے پسندیدہ کھانے",
    "noFavoritesYet": "ابھی تک کوئی پسندیدہ کھانا نہیں ہے!",
    "price": "قیمت",
    "delivery": "ڈیلیوری",
    "deliveryFee": "ڈیلیوری فیس",
    "distance": "فاصلہ",
    "subtotal": "جزوی رقم",
    "total": "کل رقم",
    "orderNumber": "آرڈر نمبر",
    "vendor": "وینڈر",
    "totalAmount": "کل رقم",
    "estimatedDelivery": "ڈیلیوری کا متوقع وقت",
    "whyThisMeal": "یہ کھانا کیوں بہتر ہے؟",
    "selectThisMeal": "یہ کھانا منتخب کریں",
    "swapMeal": "کھانا تبدیل کریں",
    "orderThisMeal": "یہ کھانا آرڈر کریں",
    "notAvailableNearYou": "آپ کے قریب دستیاب نہیں ہے",
    "tryAdjustingPrefs": "کھانے کی تجاویز دیکھنے کے لیے اپنی ترجیحات کو تبدیل کرنے کی کوشش کریں",
    "myMealPlanSummary": "میرے کھانے کے پلان کا خلاصہ",
    "saveCompletePlan": "مکمل پلان محفوظ کریں",
    "yourFoodPreferences": "آپ کے کھانے کی ترجیحات",
    "editPreferences": "ترجیحات میں ترمیم کریں",
    "healthyMealDelivery": "صحت بخش کھانے کی ڈیلیوری",
    "enableDelivery": "ڈیلیوری فعال کریں",
    "enterZipCode": "دستیاب کھانے دیکھنے کے لیے اپنا پوسٹ کوڈ / زپ درج کریں",
    "enterPostcode": "اپنا پوسٹ کوڈ / زپ کوڈ درج کریں",
    "postcodePlaceholder": "مثلاً MK10 9XX یا 10001",
    "postcodePartialHint": "درست مقامی نتائج کے لیے براہ کرم اپنا مکمل پوسٹ کوڈ درج کریں۔",
    "noLocalPartnersFallback": "ابھی تک کوئی مقامی پارٹنرز نہیں ملے۔ اس کے بجائے ثقافتی طور پر موزوں اجزاء کی تجاویز دکھائی جا رہی ہیں۔",
    "noLivePartnersFallback": "آپ کے علاقے میں ابھی تک HealthLoop کے کوئی فعال فوڈ پارٹنرز نہیں ہیں۔",
    "culturalNutritionTitle": "مقامی صحت بخش انتخاب",
    "culturalNutritionSubtitle": "صحت مند طرز زندگی کے لیے ذاتی رہنمائی — جو آپ کی ثقافت اور علاقے کے مطابق ہو۔",
    "viewIngredientGuidance": "رہنمائی دیکھیں",
    "popularWellnessTitle": "آپ کے قریب مشہور صحت بخش کھانے",
    "popularWellnessIntro": "ثقافتی طور پر موزوں اجزاء اور صحت بخش ماحول جو آپ کے علاقے میں عام ہیں۔",
    "subsectionPopularFoodsTitle": "روزمرہ کی فلاح و بہبود کے کھانے",
    "subsectionCulturalIngredientsTitle": "ثقافتی اجزاء کی تجاویز",
    "subsectionHealthySwapsTitle": "صحت بخش متبادل کے خیالات",
    "subsectionLocalEnvironmentTitle": "مقامی فلاح و بہبود کا ماحول",
    "subsectionLocalEnvironmentIntro": "وہ مقامات جہاں آپ کے علاقے کے لوگ صحت بخش انتخاب تلاش کرتے ہیں۔",
    "findLocalTitle": "مقامی صحت بخش اختیارات",
    "findLocalSubtitle": "اپنے علاقے میں قریبی صحت بخش وینڈرز، اسٹورز اور ثقافتی اجزاء دریافت کریں۔",
    "findOptions": "آپشنز تلاش کریں",
    "searching": "تلاش جاری ہے...",
    "nearbyVendorsFound": "{{count}} قریبی صحت بخش انتخاب ملے",
    "orderHintEnabled": "وینڈر کی قیمتیں دیکھنے کے لیے نیچے کسی بھی کھانے کے کارڈ پر \"یہ کھانا آرڈر کریں\" پر ٹیپ کریں۔",
    "orderHintDisabled": "براہ راست آرڈر کرنے کے لیے اوپر 'ڈیلیوری فعال کریں' کو آن کریں۔",
    "localIngredientTitle": "مقامی اجزاء کی دستیابی",
    "localIngredientIntro": "ثقافتی طور پر اہم بنیادی اشیاء اور انہیں مقامی طور پر کہاں سے حاصل کیا جائے۔",
    "lookFor": "تلاش کریں",
    "noVendorsFallback": "یہاں ابھی تک کوئی تصدیق شدہ ڈیلیوری وینڈرز نہیں ہیں — تاہم اوپر دی گئی اجزاء کی رہنمائی کسی بھی مقامی کریانہ اسٹور پر کارآمد ہے۔",
    "showingMealsFrom": "ان کی طرف سے کھانے دکھائے جا رہے ہیں:",
    "sectionSnapshot": "روزانہ کی غذائیت کا خلاصہ",
    "sectionSnapshotSubtitle": "آج کے پانی کے استعمال، کیلوریز اور کھانے کے توازن پر ایک نظر۔",
    "snapshotHydration": "پانی کا استعمال",
    "snapshotHydrationHint": "آج 6 سے 8 گلاس کا ہدف رکھیں۔",
    "snapshotCalories": "کیلوریز",
    "snapshotCaloriesHint": "ٹریکنگ جلد آرہی ہے۔",
    "snapshotBalance": "کھانے کا توازن",
    "mealsLogged": "کھانے منتخب کیے گئے",
    "snapshotTip": "تندرستی کا مشورہ",
    "snapshotTipHint": "اپنے اگلے کھانے میں ایک اضافی سبزی شامل کریں۔",
    "sectionRecommendations": "ذہین تجاویز",
    "sectionRecommendationsSubtitle": "ثقافتی لحاظ سے موزوں اجزاء کی رہنمائی اور صحت بخش متبادل خیالات۔",
    "sectionGoals": "غذائی اہداف",
    "sectionGoalsSubtitle": "ان نتائج پر نظر رکھیں جو آپ کے لیے اہم ہیں۔",
    "goalWeight": "وزن کا خیال",
    "goalWeightDesc": "وزن برقرار رکھنے کے لیے موزوں کھانے۔",
    "goalEnergy": "توانائی کی فراہمی",
    "goalEnergyDesc": "مصروف دن کے لیے بھرپور توانائی۔",
    "goalImmunity": "قوتِ مدافعت",
    "goalImmunityDesc": "تندرست رہنے کے لیے اینٹی آکسیڈینٹ سے بھرپور انتخاب۔",
    "goalFamily": "خاندانی غذائیت",
    "goalFamilyDesc": "بچوں اور ماؤں کے لیے موزوں انتخاب شامل ہیں۔",
    "sectionGuidance": "کھانے کی رہنمائی",
    "sectionGuidanceSubtitle": "ناشتہ، دوپہر اور رات کے کھانے کے خیالات جنہیں آپ تبدیل کر سکتے ہیں۔",
    "futureNutritionTitle": "مستقبل کی غذائی معاونت",
    "futureNutritionBody": "ذاتی نوعیت کی غذائیت، صحت بخش کھانے کی شراکت داری، اور خاندان پر مرکوز غذائی تعاون HealthLoop کی آئندہ اپ ڈیٹس میں شامل ہوگا۔",
    "comingSoon": "جلد آرہا ہے",
    "coverageLocalStores": "مقامی صحت بخش اسٹورز",
    "coverageLocalFarms": "مقامی فارمز",
    "coverageCertifiedVendors": "تصدیق شدہ وینڈرز",
    "coverageFreshProduce": "تازہ پیداوار",
    "medWellnessFutureTitle": "ادویات اور فلاح و بہبود کی معاونت",
    "medWellnessFutureDesc": "آپ کے غذائی پلان کو ادویات کے مطابق رہنمائی کے ساتھ جوڑتا ہے۔ اصل معلومات 'سپورٹ اور مدد' کے تحت موجود ہیں۔",
    "pharmacyAssistFutureTitle": "فارمیسی معاونت",
    "pharmacyAssistFutureDesc": "قریبی فارمیسیز اور ادویات کی یاددہانی اپنے کھانوں کے ساتھ ہی دیکھیں۔ اصل معلومات 'سپورٹ اور مدد' کے تحت موجود ہیں۔",
    "savePreferences": "ترجیحات محفوظ کریں",
    "quickAccessSavedMeals": "آپ کے محفوظ کردہ کھانوں تک فوری رسائی",
    "saveMealsFromBuilder": "میل بلڈر ٹیب سے کھانے محفوظ کریں",
    "chooseVendor": "اس کھانے کو آرڈر کرنے کے لیے وینڈر کا انتخاب کریں",
    "yourCart": "آپ کی کارٹ",
    "addMealsToStart": "شروع کرنے کے لیے نیچے دیے گئے انتخاب میں سے کھانے شامل کریں",
    "orderPlacedDesc": "آپ کے صحت بخش کھانے کا آرڈر کامیابی سے دے دیا گیا ہے",
    "continueShopping": "خریداری جاری رکھیں",
    "trackOrder": "آرڈر ٹریک کریں",
    "healthyStoresTitle": "قریبی صحت بخش اسٹورز اور فلاح و بہبود کی مارکیٹیں",
    "healthyStoresIntro": "آپ کے علاقے میں تلاش کرنے کے لیے ثقافتی طور پر جامع اسٹورز کی اقسام — صرف معلومات کے لیے، ڈیلیوری کے لیے نہیں۔",
    "healthyStoresGuidanceTitle": "صحت بخش خریداری کی رہنمائی",
    "healthyStoresDisclaimer": "HealthLoop صرف عمومی فلاح و بہبود اور صحت بخش خریداری کی ترغیبات فراہم کرتا ہے — یہ طبی یا غذائی علاج کی مشاورت نہیں ہے۔",
    "healthyStores": {
      "organic": {
        "type": "آرگینک گروسری اسٹورز",
        "description": "تازہ، کیڑے مار ادویات سے پاک اشیاء اور کم سے کم پراسیس شدہ گھریلو ضروریات کا سامان۔",
        "tags": [
          "قدرتی غذائیں",
          "تازہ پیداوار"
        ]
      },
      "farmers": {
        "type": "فارمرز مارکیٹس",
        "description": "براہ راست کاشتکاروں سے حاصل کردہ مقامی موسمی پھل، سبزیاں اور روایتی پیداوار۔",
        "tags": [
          "مقامی",
          "موسمی"
        ]
      },
      "african": {
        "type": "افریقی تازہ پیداوار کے اسٹورز",
        "description": "اروی، کیلے، پتے والی سبزیاں، پام نٹ اور مشرقی و مغربی افریقہ کی بنیادی غذائیں۔",
        "tags": [
          "ثقافتی",
          "تازہ پیداوار"
        ]
      },
      "caribbean": {
        "type": "کیریبین قدرتی فوڈ مارکیٹس",
        "description": "کالالو، کساوا، اسکاچ بونٹ، اکی، بریڈ فروٹ اور جزائر کی روایتی غذائیں۔",
        "tags": [
          "ثقافتی",
          "قدرتی غذائیں"
        ]
      },
      "asian": {
        "type": "ایشیائی سبزیوں کی سپر مارکیٹس",
        "description": "بوک چوائے، مولی، کمل کی جڑ، ٹوفو، تازہ جڑی بوٹیاں اور پین ایشیائی بنیادی غذائیں۔",
        "tags": [
          "ثقافتی",
          "تازہ پیداوار"
        ]
      },
      "halal": {
        "type": "حلال صحت بخش فوڈ مارکیٹس",
        "description": "حلال تصدیق شدہ پروٹین، تازہ پیداوار اور روایتی مصالحےاہ۔",
        "tags": [
          "حلال",
          "ثقافتی"
        ]
      },
      "mediterranean": {
        "type": "بحیرہ روم کی قدرتی فوڈ مارکیٹس",
        "description": "زیتون کا تیل، دالیں، تازہ جڑی بوٹیاں، اناج اور بحیرہ روم کی روایتی غذائیں۔",
        "tags": [
          "ثقافتی",
          "قدرتی غذائیں"
        ]
      },
      "wellness": {
        "type": "فلاح و بہبود پر مرکوز گروسری شاپس",
        "description": "منتخب کردہ قدرتی غذائیں، پودوں پر مبنی آپشنز اور صاف ستھری اشیاء۔",
        "tags": [
          "قدرتی غذائیں",
          "پودوں پر مبنی"
        ]
      }
    },
    "healthyShoppingTips": [
      "پہلے اسٹور کے بیرونی حصوں کا رخ کریں — تازہ پیداوار، پروٹین اور متبادل دودھ عام طور پر کناروں پر ہوتے ہیں۔",
      "زیادہ پراسیس شدہ اشیاء کے بجائے قدرتی اور سادہ اجزاء والی غذاؤں کو ترجیح دیں۔",
      "موسمی مقامی پیداوار کا انتخاب کریں — یہ عام طور پر زیادہ تازہ، سستی اور غذائیت سے بھرپور ہوتی ہے۔",
      "وینڈرز سے اشیاء کے ماخذ اور اگانے کے طریقوں کے بارے میں پوچھیں — بہت سے لوگ خوشی سے معلومات شیئر کرتے ہیں۔"
    ]
  },
  "messages": {
    "success": "کامیابی!",
    "error": "غلطی",
    "saved": "کامیابی سے محفوظ ہو گیا",
    "updated": "کامیابی سے اپ ڈیٹ ہو گیا",
    "deleted": "کامیابی سے حذف ہو گیا",
    "confirmDelete": "کیا آپ واقعی اسے حذف کرنا چاہتے ہیں؟",
    "networkError": "نیٹ ورک کی خرابی۔ براہ کرم دوبارہ کوشش کریں۔",
    "somethingWrong": "کچھ غلط ہو گیا",
    "failedToLoad": "ڈیش بورڈ لوڈ کرنے میں ناکامی ہوئی",
    "offlineMode": "آف لائن موڈ - محدود ڈیٹا دکھایا جا رہا ہے",
    "locationDenied": "لوکیشن تک رسائی مسترد کر دی گئی۔ فعال کرنے کے لیے براؤزر کی ترتیبات چیک کریں۔",
    "locationUnavailable": "مقام کی معلومات دستیاب نہیں ہے",
    "locationTimeout": "لوکیشن کی درخواست کا وقت ختم ہو گیا۔ دوبارہ کوشش کریں۔",
    "locationError": "لوکیشن تک رسائی حاصل کرنے میں ناکامی",
    "locationGranted": "لوکیشن تک رسائی مل گئی! قریبی آپشنز دکھائے جا رہے ہیں",
    "locationNotSupported": "آپ کا براؤزر لوکیشن سروسز کی حمایت نہیں کرتا",
    "requestingLocation": "لوکیشن تک رسائی کی درخواست کی جا رہی ہے..."
  },
  "trust": {
    "medicalDisclaimer": "طبی دستبرداری",
    "privacySecure": "آپ کا ڈیٹا نجی اور محفوظ ہے",
    "dataEncrypted": "تمام ڈیٹا انکرپٹڈ اور خفیہ ہے",
    "notMedicalAdvice": "یہ طبی مشورہ نہیں ہے",
    "consultProvider": "ہمیشہ اپنے ہیلتھ کیئر فراہم کنندہ سے مشورہ کریں",
    "evidenceBased": "شواہد پر مبنی رہنمائی",
    "generalEducation": "عمومی صحت کی تعلیم",
    "preventiveGuidance": "احتیاطی رہنمائی",
    "lifestyleSupport": "آگاہی اور طرز زندگی کی معاونت کے لیے",
    "lastUpdated": "آخری بار اپ ڈیٹ کیا گیا",
    "expertReviewed": "ماہرین کی جانچ شدہ",
    "aiGenerated": "AI کی تیار کردہ معلومات",
    "disclaimerShort": "HealthLoop صحت کی تعلیم فراہم کرتا ہے اور پیشہ ورانہ طبی مشورے کا متبادل نہیں ہے۔",
    "disclaimerFull": "HealthLoop احتیاطی تندرستی اور بروقت آگاہی میں مدد کرتا ہے۔ ہم صحت کی تعلیم، عادات کی ٹریکنگ، اور فلاح و بہبود کی بصیرت فراہم کرتے ہیں۔ یہ لائسنس یافتہ طبی دیکھ بھال کا متبادل نہیں ہے۔ طبی مشورے، تشخیص، یا کسی بھی طبی عمل کے لیے ہمیشہ مستند ہیلتھ کیئر فراہم کنندگان سے رجوع کریں۔",
    "trustBanner": {
      "title": "HealthLoop آپ کے تندرستی کے سفر میں آپ کا ساتھی ہے",
      "description": "ہم مستند ذرائع کی بنیاد پر عمومی صحت کی تعلیم اور احتیاطی رہنمائی فراہم کرتے ہیں۔ یہ پیشہ ورانہ طبی مشورے کا متبادل نہیں ہے۔ طبی فیصلوں کے لیے ہمیشہ مستند ہیلتھ کیئر فراہم کنندگان سے مشورہ کریں۔"
    }
  },
  "health": {
    "preventiveHealth": "احتیاطی صحت کا ٹریکر",
    "educationHub": "تعلیمی مرکز",
    "engagementWidget": "انگیجمنٹ ویجیٹ",
    "wellnessCheckIn": "تندرستی کا جائزہ",
    "todaysMetrics": "آج کے اعداد و شمار",
    "bloodPressure": "بلڈ پریشر",
    "heartRate": "دل کی دھڑکن",
    "weight": "وزن",
    "sleep": "نیند",
    "waterIntake": "پانی کا استعمال",
    "exercise": "ورزش",
    "logMetric": "اعداد و شمار درج کریں",
    "viewHistory": "ہسٹری دیکھیں"
  },
  "aiInsights": {
    "title": "AI صحت کی بصیرت",
    "comingSoon": "آپ کی بصیرتیں جمع ہو رہی ہیں",
    "comingSoonDesc": "ایک دو دن کا جائزہ مکمل کریں اور ہم یہاں آپ کے لیے ذاتی نوعیت کی بصیرتیں پیش کریں گے۔",
    "learnMore": "مزید جانیں",
    "evidenceSources": {
      "WHO": "WHO کی ہدایات کی بنیاد پر",
      "NHS": "NHS کی سفارشات کے مطابق",
      "CDC": "CDC کی ہدایات سے تائید شدہ",
      "RESEARCH": "تحقیقی مقالوں کی بنیاد پر",
      "CLINICAL": "کلینیکل اسٹڈیز کی بنیاد پر"
    }
  },
  "dailyInsight": {
    "title": "روزانہ کی صحت کی بصیرت",
    "gettingStarted": "آغاز کریں",
    "focus": "توجہ کا مرکز",
    "quickInsight": "فوری بصیرت",
    "simpleExplanation": "آسان وضاحت",
    "realLifeImpact": "روزمرہ زندگی پر اثر",
    "yourActionStep": "آپ کا عملی قدم",
    "basedOnYour": "آپ کی بنیاد پر",
    "personalizedFor": "آپ کے حالیہ صحت کے ڈیٹا کی بنیاد پر آپ کے لیے مخصوص",
    "getNewInsight": "نئی بصیرت حاصل کریں",
    "newInsightLoaded": "نئی بصیرت لوڈ ہو گئی! 💡",
    "failedToRefresh": "بصیرت کو ریفریش کرنے میں ناکامی ہوئی",
    "priority": {
      "high": "آئیے یہاں توجہ دیں",
      "medium": "قابل غور"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "اس وقت صحت سے متعلق کوئی الرٹ نہیں ہے",
    "noAlertsDesc": "آپ صحت مند عادات برقرار رکھے ہوئے ہیں۔ اسے جاری رکھیں!",
    "whatYouCanDo": "آپ کیا کر سکتے ہیں:",
    "viewMealSuggestions": "ذاتی نوعیت کی کھانے کی تجاویز دیکھیں"
  },
  "engagement": {
    "currentStreak": "موجودہ تسلسل",
    "bestStreak": "بہترین تسلسل",
    "thisWeek": "اس ہفتے",
    "exerciseDays": "ورزش کے دن",
    "hydrationDays": "پانی پینے کے دن",
    "healthMetricsLogged": "درج شدہ طبی اعداد و شمار",
    "weeklyGoalsProgress": "ہفتہ وار اہداف کی پیشرفت",
    "completed": "مکمل",
    "days": "دن",
    "keepGoing": "جاری رکھیں!",
    "personalRecord": "ذاتی ریکارڈ!",
    "goalMet": "ہدف مکمل!"
  },
  "reminders": {
    "title": "صحت کی یاددہانی",
    "subtitle": "ذاتی نوعیت کے نوٹیفیکیشنز کے ساتھ اپنے پلان پر قائم رہیں",
    "breakfast": "ناشتے کی یاددہانی",
    "lunch": "دوپہر کے کھانے کی یاددہانی",
    "dinner": "رات کے کھانے کی یاددہانی",
    "water": "پانی کا استعمال",
    "movement": "چہل قدمی کا وقفہ",
    "sleep": "نیند کی یاددہانی",
    "wellness": "تندرستی کا جائزہ",
    "healthLogging": "صحت کا اندراج",
    "annualCheckup": "سالانہ معائنہ",
    "enable": "فعال کریں",
    "disable": "غیر فعال کریں",
    "customize": "وقت متعین کریں",
    "stayConsistent": "سمارٹ ریمائنڈرز کے ساتھ باقاعدہ رہیں",
    "setupFriendly": "صحت مند عادات بنانے کے لیے دوستانہ یاددہانی سیٹ کریں۔",
    "customizeWhen": "آپ ریمائنڈر کے وقت اور فریکوئنسی کو اپنی مرضی سے بدل سکتے ہیں۔",
    "supportive": "فکر نہ کریں - ہم انہیں حوصلہ افزا اور سادہ رکھیں گے! 💚",
    "noPreferences": "کوئی ترجیحات نہیں ملیں",
    "noPreferencesDesc": "ہم آپ کی ریمائنڈر سیٹنگز لوڈ نہیں کر سکے۔ ہو سکتا ہے یہ آپ کا پہلا موقع ہو یا لوڈنگ میں کوئی مسئلہ ہو۔",
    "retryLoading": "دوبارہ کوشش کریں",
    "saveSettings": "سیٹنگز محفوظ کریں",
    "saving": "محفوظ ہو رہا ہے..."
  },
  "empty": {
    "startJourney": "اپنی تندرستی کے سفر کا آغاز کریں",
    "startJourneyDesc": "آج ہی سے اپنی صحت کے سفر کا آغاز کریں! اپنی کیفیت بتائیں تاکہ آپ کو ذاتی نوعیت کی بصیرتیں مل سکیں۔",
    "completeFirstCheckIn": "پہلا جائزہ مکمل کریں",
    "stayOnTrack": "پلان پر قائم رہیں",
    "stayOnTrackDesc": "اپنے معمولات پر ثابت قدم رہیں 💊 بروقت یاددہانی کے لیے اپنی ادویات شامل کریں۔",
    "addFirstMedication": "پہلی دوا شامل کریں",
    "learnMedicationSafety": "ادویات کی حفاظت کے بارے میں جانیں",
    "buildMealLibrary": "اپنی کھانوں کی لائبریری بنائیں",
    "buildMealLibraryDesc": "ابھی تک کوئی پسندیدہ کھانا نہیں ہے۔ فوری رسائی کے لیے اپنے پسندیدہ کھانے محفوظ کریں۔",
    "exploreMealOptions": "کھانوں کے انتخاب دریافت کریں",
    "insightsAwait": "آپ کی بصیرتیں تیار ہیں",
    "insightsAwaitDesc": "ذاتی نوعیت کی صحت کی بصیرتیں حاصل کرنے کے لیے روزانہ جائزہ مکمل کریں۔",
    "startDailyCheckIn": "روزانہ کا جائزہ شروع کریں",
    "learnAboutInsights": "بصیرت کے بارے میں جانیں",
    "buildingStory": "آپ کی تندرستی کی کہانی بن رہی ہے",
    "buildingStoryDesc": "ابھی کوئی پرانا ڈیٹا نہیں ہے۔ روزانہ کے جائزے کے ساتھ آپ کے رجحانات یہاں نظر آئیں گے۔",
    "completeCheckIn": "جائزہ مکمل کریں",
    "tipComplete7Days": "مشورہ: بامعنی نتائج اور رجحانات دیکھنے کے لیے 7 دن تک جائزہ مکمل کریں۔",
    "startTrackingHabits": "صحت مند عادات کو ٹریک کرنا شروع کریں",
    "startTrackingHabitsDesc": "ابھی تک کوئی عادت ٹریک نہیں کی گئی۔ چھوٹی روزانہ کی تبدیلیاں بڑی بہتری لاتی ہیں۔",
    "trackFirstHabit": "پہلی عادت ٹریک کریں",
    "getMoving": "حرکت میں آئیں",
    "getMovingDesc": "ابھی تک کوئی سرگرمی درج نہیں کی۔ صرف 10 منٹ کی چہل قدمی بھی آپ کے مزاج کو بہتر بنا سکتی ہے۔",
    "logActivity": "سرگرمی درج کریں",
    "allCaughtUp": "سب اپ ٹو ڈیٹ ہے!",
    "allCaughtUpDesc": "آپ کے پاس کوئی نیا نوٹیفیکیشن نہیں ہے۔ مزید معلومات کے لیے بعد میں چیک کریں۔",
    "noResultsFound": "کوئی نتیجہ نہیں ملا",
    "noResultsFoundDesc": "ہمیں \"{query}\" کے لیے کوئی نتیجہ نہیں ملا۔ اپنی تلاش بدل کر کوشش کریں۔"
  },
  "footer": {
    "tagline": "آپ کا AI پر مبنی حفاظتی صحت کا ساتھی",
    "builtWith": "آپ کے فلاحی سفر کے لیے نہایت توجہ سے تیار کیا گیا",
    "allRightsReserved": "جملہ حقوق محفوظ ہیں۔",
    "about": "ہمارے بارے میں",
    "privacy": "رازداری",
    "terms": "شرائط و ضوابط",
    "contact": "رابطہ کریں",
    "helpCenter": "امدادی مرکز"
  },
  "modals": {
    "feedback": {
      "title": "اپنی رائے دیں",
      "subtitle": "HealthLoop کو بہتر بنانے میں ہماری مدد کریں",
      "whatWorking": "کون سی چیز بہتر کام کر رہی ہے؟",
      "whatImprove": "ہم کہاں بہتری لا سکتے ہیں؟",
      "placeholder": "اپنے خیالات شیئر کریں...",
      "thankYou": "آپ کی رائے کا شکریہ!",
      "submitted": "آپ کی رائے ہمیں HealthLoop کو مزید بہتر بنانے میں مدد دیتی ہے۔"
    },
    "reportProblem": {
      "title": "مسئلے کی اطلاع دیں",
      "subtitle": "خرابیاں دور کرنے اور ایپ کو بہتر بنانے میں ہماری مدد کریں",
      "describe": "مسئلے کی وضاحت کریں",
      "placeholder": "کیا ہوا؟ براہ کرم تفصیل سے بتائیں...",
      "optional": "اختیاری: مسئلے تک پہنچنے کے مراحل",
      "stepsPlaceholder": "1. میں نے اس پر کلک کیا...\n2. پھر میں نے...",
      "thankYou": "اطلاع دینے کے لیے شکریہ!",
      "submitted": "ہم فوری طور پر اس کا جائزہ لیں گے۔"
    },
    "mealPreferences": {
      "title": "اپنے کھانوں کو اپنی پسند کے مطابق بنائیں",
      "subtitle": "ہمیں اپنی غذائی ترجیحات کے بارے میں بتائیں",
      "cuisines": "پسندیدہ کھانے",
      "selectCuisines": "ان سب کا انتخاب کریں جو آپ کو پسند ہیں",
      "dietary": "غذائی ترجیحات",
      "selectDietary": "اپنی غذائی ضروریات منتخب کریں",
      "allergies": "الرجی اور پابندیاں",
      "allergiesPlaceholder": "مثلاً خشک میوہ جات، سمندری خوراک، گلوٹین",
      "save": "ترجیحات محفوظ کریں",
      "saving": "محفوظ ہو رہا ہے..."
    },
    "upgrade": {
      "title": "پریمیم میں اپ گریڈ کریں",
      "subtitle": "تمام فیچرز تک رسائی حاصل کریں",
      "features": "پریمیم فیچرز",
      "getStarted": "آغاز کریں",
      "learnMore": "مزید جانیں"
    }
  },
  "login": {
    "title": "آپ کا حفاظتی صحت کا ذہین پلیٹ فارم",
    "subtitle": "مسائل بڑھنے سے پہلے ان کا سراغ لگائیں، سیکھیں اور اقدامات کریں۔ یہ بچاؤ، تعلیم، آگاہی اور تندرستی کے لیے بنایا گیا ہے۔",
    "email": "ای میل",
    "password": "پاس ورڈ",
    "signIn": "سائن ان کریں",
    "signingIn": "سائن ان ہو رہا ہے...",
    "forgotPassword": "پاس ورڈ بھول گئے؟",
    "noAccount": "اکاؤنٹ نہیں ہے؟",
    "createAccount": "نیا بنائیں",
    "biometricLogin": "بایومیٹرک کے ساتھ سائن ان کریں",
    "biometricHelper": "فنگر پرنٹ، Face ID، یا Windows Hello استعمال کریں",
    "authenticating": "تصدیق ہو رہی ہے...",
    "vendorPartner": "کیا آپ وینڈر پارٹنر ہیں؟",
    "vendorLogin": "وینڈر لاگ ان",
    "emailRequired": "براہ کرم پہلے اپنا ای میل درج کریں",
    "biometricSuccess": "بایومیٹرک کے ذریعے کامیابی سے سائن ان ہو گیا! 🎉",
    "noPasskeys": "کوئی بایومیٹرک لاگ ان سیٹ اپ نہیں ہے۔ براہ کرم پہلے پاس ورڈ استعمال کریں۔",
    "biometricCancelled": "بایومیٹرک لاگ ان منسوخ کر دیا گیا",
    "biometricFailed": "بایومیٹرک لاگ ان ناکام ہو گیا۔ براہ کرم پاس ورڈ کے ذریعے کوشش کریں۔"
  },
  "register": {
    "title": "HealthLoop میں شامل ہوں",
    "subtitle": "آج ہی اپنے حفاظتی صحت کے سفر کا آغاز کریں",
    "fullName": "پورا نام",
    "email": "ای میل",
    "password": "پاس ورڈ",
    "confirmPassword": "پاس ورڈ کی تصدیق کریں",
    "createAccount": "اکاؤنٹ بنائیں",
    "haveAccount": "پہلے سے اکاؤنٹ موجود ہے؟",
    "signIn": "سائن ان کریں",
    "creating": "اکاؤنٹ بن رہا ہے...",
    "passwordTooShort": "پاس ورڈ کم از کم 8 حروف پر مشتمل ہونا چاہیے",
    "setupBiometric": "بایومیٹرک لاگ ان سیٹ اپ کریں",
    "setupBiometricDesc": "تیز رفتار اور محفوظ لاگ ان کے لیے اپنا فنگر پرنٹ، Face ID یا Windows Hello استعمال کریں",
    "setupNow": "ابھی سیٹ اپ کریں",
    "skipForNow": "ابھی رہنے دیں",
    "settingUp": "سیٹ اپ ہو رہا ہے...",
    "benefit1": "اب پاس ورڈ یاد رکھنے کی ضرورت نہیں",
    "benefit2": "بایومیٹرک تصدیق کے ساتھ اضافی سیکیورٹی",
    "benefit3": "صرف ایک لمس یا جھلک سے سائن ان کریں",
    "biometricPrivacy": "آپ کا بایومیٹرک ڈیٹا کبھی بھی آپ کے آلے سے باہر نہیں جاتا",
    "biometricSuccess": "بایومیٹرک لاگ ان کامیابی سے سیٹ اپ ہو گیا! 🎉",
    "biometricFailed": "بایومیٹرک لاگ ان سیٹ اپ کرنے میں ناکامی۔ آپ اسے بعد میں سیٹنگز میں سیٹ کر سکتے ہیں۔",
    "biometricSetupLater": "آپ اپنے پروفائل کی سیٹنگز میں بعد میں بایومیٹرک لاگ ان سیٹ اپ کر سکتے ہیں"
  },
  "womensHealthPage": {
    "title": "خواتین کی صحت کا ٹریکر",
    "subtitle": "اپنے ماہانہ دورانیے، علامات اور تندرستی کا ریکارڈ رکھیں",
    "cycleOverview": "سائیکل کا جائزہ",
    "currentPhase": "موجودہ مرحلہ",
    "nextPeriod": "متوقع اگلا ماہانہ دورانیہ",
    "logPeriod": "دورانیہ درج کریں",
    "logSymptoms": "علامات درج کریں",
    "insights": "سائیکل سے متعلق معلومات",
    "tips": "مرحلے کے لحاظ سے مفید مشورے",
    "history": "سابقہ ریکارڈ",
    "noData": "ابھی تک کوئی ڈیٹا موجود نہیں",
    "noDataDesc": "ذاتی نوعیت کی معلومات اور پیش گوئیوں کے لیے اپنے سائیکل کا ریکارڈ رکھنا شروع کریں۔",
    "startTracking": "ریکارڈ رکھنا شروع کریں"
  },
  "notifications": {
    "title": "اطلاعات",
    "markAllRead": "سب کو پڑھا ہوا قرار دیں",
    "noNotifications": "کوئی نئی اطلاع نہیں ہے",
    "viewAll": "سب دیکھیں"
  },
  "familyHealth": {
    "title": "خاندان اور بچوں کی صحت",
    "subtitle": "آپ کے پورے خاندان کے لیے حفاظتی صحت کی رہنمائی",
    "tabImmunizations": "حفاظتی ٹیکے",
    "tabEducation": "تعلیم و آگاہی",
    "tabReminders": "یاد دہانی",
    "tabPlanner": "فیملی پلانر",
    "immunizations": {
      "title": "حفاظتی ٹیکوں کی آگاہی",
      "subtitle": "تجویز کردہ ویکسینز کے بارے میں باخبر رہیں",
      "recommendedSchedule": "تجویز کردہ شیڈول",
      "byAge": "عمر کے گروپ کے لحاظ سے",
      "infants": "شیر خوار بچے (0-12 ماہ)",
      "toddlers": "گھٹنوں چلنے والے بچے (1-3 سال)",
      "preschool": "پری اسکول (4-6 سال)",
      "schoolAge": "اسکول جانے والے بچے (7-12 سال)",
      "teens": "نوجوان (13-18 سال)",
      "adults": "بالغ افراد",
      "learnMore": "مزید جانیں",
      "consultDoctor": "ویکسین کی ذاتی سفارشات کے لیے ہمیشہ اپنے صحت کے ماہر سے مشورہ کریں",
      "upcomingReminders": "ویکسین کی آنے والی یاد دہانیاں",
      "noReminders": "آنے والی کوئی یاد دہانی نہیں ہے",
      "addReminder": "ویکسین کی یاد دہانی شامل کریں",
      "reminderFor": "کس کے لیے یاد دہانی",
      "dueDate": "آخری تاریخ",
      "notes": "نوٹس",
      "markComplete": "مکمل قرار دیں"
    },
    "education": {
      "title": "خاندانی صحت کی تعلیم",
      "subtitle": "شواہد پر مبنی حفاظتی صحت کی معلومات",
      "categories": "اقسام",
      "infant": "شیر خوار بچوں کی دیکھ بھال",
      "child": "بچوں کی نشوونما",
      "nutrition": "غذائیت اور بڑھوتری",
      "safety": "حفاظت اور بچاؤ",
      "mental": "ذہنی تندرستی",
      "hygiene": "صفائی اور عادات",
      "searchPlaceholder": "صحت کے موضوعات تلاش کریں...",
      "popularTopics": "مشہور موضوعات",
      "readMore": "مزید پڑھیں",
      "readTime": "منٹ کا مطالعہ"
    },
    "reminders": {
      "title": "خاندانی صحت کی یاد دہانیاں",
      "subtitle": "پورے خاندان کی حفاظتی دیکھ بھال کے ساتھ جڑے رہیں",
      "createReminder": "یاد دہانی بنائیں",
      "familyMember": "خاندان کا رکن",
      "reminderType": "یاد دہانی کی قسم",
      "frequency": "تعدد (بار بار ہونا)",
      "activeReminders": "فعال یاد دہانیاں",
      "upcomingThisWeek": "اس ہفتے آنے والی",
      "noActiveReminders": "کوئی فعال یاد دہانی نہیں ہے",
      "types": {
        "checkup": "صحت کا معائنہ",
        "dental": "دانتوں کا معائنہ",
        "vision": "آنکھوں کا ٹیسٹ",
        "vaccine": "حفاظتی ٹیکے",
        "medication": "ادویات",
        "custom": "دیگر"
      }
    },
    "planner": {
      "title": "فیملی ہیلتھ پلانر",
      "subtitle": "اپنے خاندان کی حفاظتی دیکھ بھال کو منظم کریں",
      "addMember": "خاندان کے رکن کو شامل کریں",
      "memberName": "رکن کا نام",
      "relationship": "رشتہ",
      "dateOfBirth": "تاریخِ پیدائش",
      "viewCalendar": "کیلنڈر دیکھیں",
      "upcomingCare": "آنے والی حفاظتی دیکھ بھال",
      "nothingScheduled": "ابھی کچھ طے نہیں ہوا",
      "scheduleCheckup": "معائنہ طے کریں",
      "relationships": {
        "child": "بچہ",
        "spouse": "شریک حیات",
        "parent": "والدین",
        "sibling": "بہن بھائی",
        "other": "دیگر"
      }
    },
    "content": {
      "infantCare": {
        "title": "شیر خوار بچوں کی حفاظتی دیکھ بھال",
        "intro": "آپ کے بچے کے پہلے سال کے لیے ضروری حفاظتی صحت کے طریقے",
        "topics": [
          "بچوں کے معائنے کا شیڈول",
          "نشوونما کے اہم سنگ میل",
          "سونے کے محفوظ طریقے",
          "غذائیت اور خوراک",
          "حفاظتی ٹیکوں کا شیڈول"
        ]
      },
      "childDevelopment": {
        "title": "بچوں کی نشوونما اور سنگ میل",
        "intro": "صحت مند بڑھوتری اور ترقی کو سمجھنا",
        "topics": [
          "جسمانی نشوونما کے سنگ میل",
          "سماجی اور جذباتی بڑھوتری",
          "زبان کی نشوونما",
          "ذہنی و شعوری سنگ میل",
          "ڈاکٹر سے کب رجوع کریں"
        ]
      },
      "nutrition": {
        "title": "غذائیت اور صحت مند نشوونما",
        "intro": "شروع سے ہی کھانے کی صحت مند عادات ڈالنا",
        "topics": [
          "عمر کے مطابق غذائیت",
          "صحت بخش اسنیکس کے آئیڈیاز",
          "کھانے میں نخرے کرنے والے بچوں کو سنبھالنا",
          "خوراک کی حفاظت کے بنیادی اصول",
          "پانی پینے سے متعلق ہدایات"
        ]
      },
      "safety": {
        "title": "حفاظت اور چوٹوں سے بچاؤ",
        "intro": "اپنے خاندان کے لیے ایک محفوظ ماحول بنانا",
        "topics": [
          "گھر کی حفاظت کی فہرست",
          "کار سیٹ کی حفاظت",
          "پانی میں حفاظت",
          "زہر خورانی سے بچاؤ",
          "ہنگامی حالات کی تیاری"
        ]
      }
    }
  }
};
